
$(document).ready(function () {
    DevExpress.localization.locale('it');
});

const Costanti = {
    ESITO_OK: 'ok',
    ESITO_KO: 'ko',
    NOTIFY_COLOR_SUCCESS: 'success',
    NOTIFY_COLOR_ERROR: 'error',
    NOTIFY_COLOR_WARNING: 'warning',
    NOTIFY_COLOR_INFO: 'info',
    TIPO_SOTTODOCUMENTO_SUPPORTI_MARKETING: 48
};

$(document).ready(function () {
    setTimeout(() => {
        SetDDLCommonSettings();
        SetFileUploaderCommonSettings();
        DataGridCommonSettings();
    }, 100);

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
});



function SetDDLCommonSettings() {
    try {
        $('.dx-selectbox.dx-textbox').each(function (index, value) {
            try {
                var instanzaOggetto = $(value).dxSelectBox('instance');

                instanzaOggetto.option('placeholder', '-Seleziona-');
                instanzaOggetto.option('noDataText', 'Nessun dato');
                instanzaOggetto.option('cancelButtonText', 'Cancella');
                instanzaOggetto.option('maskInvalidMessage', 'Valore non valido');
                instanzaOggetto.option('onOpened', function (e) {
                    e.component._list.option('pageLoadingText', 'Caricamento...');
                });
            }
            catch (err) {
                console.log(err);
                console.log(instanzaOggetto);
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

function SetFileUploaderCommonSettings() {
    try {

        $('.dx-fileuploader').each(function (index, value) {
            try {

                var instanzaOggetto = $(value).dxFileUploader('instance');

                instanzaOggetto.option('readyToUploadMessage', 'File pronto al caricamento');
                instanzaOggetto.option('invalidFileExtensionMessage', 'Formato file non corretto');
                instanzaOggetto.option('invalidMaxFileSizeMessage', 'File troppo pesante');
                instanzaOggetto.option('invalidMinFileSizeMessage', 'File troppo piccolo');
                instanzaOggetto.option('uploadAbortedMessage', 'Caricamento annullato');
                instanzaOggetto.option('uploadFailedMessage', 'Errore nel caricamento del file');
                instanzaOggetto.option('uploadButtonText', 'Carica file');
                instanzaOggetto.option('uploadedMessage', 'File caricato');
                instanzaOggetto.option('labelText', 'o Rilascia il file qui');
                instanzaOggetto.option('validationError', { message: 'Campo obbligatorio' });

                var ID = instanzaOggetto.option('inputAttr')?.id;

                if (ID.length > 0) {

                    $('#' + ID + ' .dx-fileuploader-wrapper')
                        .addClass('position-relative')
                        .append($('<span>').text('delete')
                            .addClass('material-symbols-outlined file-uploader-delete-button text-danger')
                            .attr('title', 'Rimuovi file caricato')
                            .attr('onclick', '$(\'#' + ID + '\').dxFileUploader(\'instance\').reset(); if ($(\'#DocNomeFile\').length > 0) { $(\'#DocNomeFile\').val(\'\'); }')
                        );
                }

            } catch (error) {
                console.log(error);
            }
        });

    } catch (error) {
        console.log(error);
    }
}
const griglieRicaricate = [];

function DataGridCommonSettings() {
    $('.dx-datagrid.dx-gridbase-container').each(function (index, item) {
        try {
            var element = $(item).parent();

            if (element && element.length > 0) {
                if (griglieRicaricate.includes(element[0].id) == false) {

                    var grid = element.dxDataGrid('instance');

                    var totalCount = grid.getDataSource()?._totalCount;

                    if (totalCount > 0) {
                        griglieRicaricate.push(element[0].id);
                    }

                    grid.option('noDataText', 'Nessun risultato');
                    grid.option('loadPanel').text = 'Caricamento...';

                    var PageSize = 15;
                    grid.option('paging').pageSize = PageSize;
                    grid.option('pager').visible = totalCount > PageSize;
                    grid.option('pager').showNavigationButtons = totalCount > PageSize;
                    grid.option('pager').showInfo = totalCount > PageSize;
                    grid.option('pager').infoText = 'Pagina {0} di {1} ({2} risultati)';
                    grid.option('pager').allowedPageSizes = [10, 15, 25, 50];
                    grid.option('pager').showPageSizeSelector = true;

                    grid.option('editing').texts.addRow = 'Aggiungi un record';
                    grid.option('editing').texts.deleteRow = 'Elimina';
                    grid.option('editing').texts.editRow = 'Modifica';
                    grid.option('editing').texts.cancelAllChanges = 'Annulla modifiche';
                    grid.option('editing').texts.cancelRowChanges = 'Cancella';
                    grid.option('editing').texts.confirmDeleteMessage = 'Sei sicuro di voler eliminare la riga?';
                    grid.option('editing').texts.saveAllChanges = 'Salva modifiche';
                    grid.option('editing').texts.saveRowChanges = 'Salva';
                    grid.option('editing').texts.undeleteRow = 'Non cancellare';
                    grid.option('editing').texts.validationCancelChanges = 'Cancella modifiche';

                    //grid.option('filterRow').showOperationChooser = false;
                    grid.option('filterRow').applyFilterText = 'Applica filtro';
                    grid.option('filterRow').betweenEndText = 'Fine';
                    grid.option('filterRow').betweenStartText = 'Inizio';
                    grid.option('filterRow').showAllText = '-Seleziona-';
                    grid.option('filterRow').operationDescriptions.between = 'Tra';
                    grid.option('filterRow').operationDescriptions.contains = 'Include';
                    grid.option('filterRow').operationDescriptions.endsWith = 'Finisce con';
                    grid.option('filterRow').operationDescriptions.equal = 'Uguale a';
                    grid.option('filterRow').operationDescriptions.greaterThan = 'É più grande di';
                    grid.option('filterRow').operationDescriptions.greaterThanOrEqual = 'É più grande o uguale a';
                    grid.option('filterRow').operationDescriptions.isBlank = 'É vuoto';
                    grid.option('filterRow').operationDescriptions.isNotBlank = 'Non è vuoto';
                    grid.option('filterRow').operationDescriptions.lessThan = 'É minore di';
                    grid.option('filterRow').operationDescriptions.lessThanOrEqual = 'É minore o uguale a';
                    grid.option('filterRow').operationDescriptions.notContains = 'Non contiene';
                    grid.option('filterRow').operationDescriptions.notEqual = 'Diverso da';
                    grid.option('filterRow').operationDescriptions.startsWith = 'Inizia con';
                    grid.option('filterRow').resetOperationText = 'Reimposta';

                    grid.option('headerFilter').texts.cancel = 'Cancella';
                    grid.option('headerFilter').texts.emptyValue = '-Seleziona-';
                    grid.option('headerFilter').texts.ok = 'OK';

                    grid.option('filterBuilder').filterOperationDescriptions.between = 'Tra';
                    grid.option('filterBuilder').filterOperationDescriptions.contains = 'Include';
                    grid.option('filterBuilder').filterOperationDescriptions.endsWith = 'Finisce con';
                    grid.option('filterBuilder').filterOperationDescriptions.equal = 'Uguale a';
                    grid.option('filterBuilder').filterOperationDescriptions.greaterThan = 'É più grande di';
                    grid.option('filterBuilder').filterOperationDescriptions.greaterThanOrEqual = 'É più grande o uguale a';
                    grid.option('filterBuilder').filterOperationDescriptions.isBlank = 'É vuoto';
                    grid.option('filterBuilder').filterOperationDescriptions.isNotBlank = 'Non è vuoto';
                    grid.option('filterBuilder').filterOperationDescriptions.lessThan = 'É minore di';
                    grid.option('filterBuilder').filterOperationDescriptions.lessThanOrEqual = 'É minore o uguale a';
                    grid.option('filterBuilder').filterOperationDescriptions.notContains = 'Non contiene';
                    grid.option('filterBuilder').filterOperationDescriptions.notEqual = 'Diverso da';
                    grid.option('filterBuilder').filterOperationDescriptions.startsWith = 'Inizia con';
                    grid.option('filterBuilder').groupOperationDescriptions.and = 'E';
                    grid.option('filterBuilder').groupOperationDescriptions.notAnd = 'E non';
                    grid.option('filterBuilder').groupOperationDescriptions.notOr = 'O non';
                    grid.option('filterBuilder').groupOperationDescriptions.Or = 'O';

                    grid.option('onContextMenuPreparing', function (e) {
                        console.log(e);
                        if (e.target === 'header' || e.target === 'headerPanel') {
                            e.items = null;
                        }
                    });

                    grid.repaint();
                    grid.getDataSource().reload();
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    });
}

function dateformat(v) {
    if (v === null || v === 'undefined') {
        return '';
    }
    else {
        try {
            if (typeof v === 'string' || v instanceof String) {
                v = new Date(v);
            }
            let date, month, year;

            date = v.getDate();
            month = v.getMonth() + 1;
            year = v.getFullYear();

            date = date
                .toString()
                .padStart(2, '0');

            month = month
                .toString()
                .padStart(2, '0');

            return `${date}/${month}/${year}`;
        } catch (error) {
            return '';
        }

    }
    //return formatDate(new Date(v));
}

function IsEmail(email) {
    if (email != null && email != undefined && email != '') {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        return emailReg.test(email);
    }

    return false;
}

function decodeHTMLEntity(encodedString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = encodedString;
    return tempElement.textContent || tempElement.innerText;
}

function CallService(c_url, params) {
    var r = null;
    $.ajax({
        url: c_url,
        data: params,
        async: false,
        success: function (result) {
            r = result;
        },
        error: function (error) {
            console.log(error);
        }
    });

    return r;
}

function CallServiceFormData(c_url, params) {
    let r = null;
    $.ajax({
        url: c_url,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: params,
        contentType: false,
        processData: false,
        async: false,
        success: function (result) {
            r = result;
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(xhr);
            console.log(ajaxOptions);
            console.log(thrownError);
        }
    });

    return r;
}
function CallServiceFormDataAsync(c_url, params) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: c_url,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: params,
            contentType: false,
            processData: false,
            success: function (result) {
                resolve(result);
            },
            error: function (xhr, status, error) {
                reject(error);
            }
        });
    });
}

function CallServiceAsync(c_url, params) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: c_url,
            data: params,
            type: 'POST',
            dataType: 'json',
            success: function (result) {
                resolve(result);
            },
            error: function (xhr, status, error) {
                reject(error);
            }
        });
    });
}

function CallServiceAsyncGetFile(c_url) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: c_url,
            type: 'GET',
            processData: false,
            async: true,
            responseType: 'arraybuffer',
            success: function (result) {
                resolve(result);
            },
            error: function (xhr, status, error) {
                reject(error);
            }
        });
    });
}

var Notify = (function () {
    /**
    * Visualizza una notifica a monitor attraverso il componente di DevExpress.
    * @param {string} text - testo da visualizzare nella notifica
    * @param {string} color - colore da utilizzare per la notifica secondo la nomenclatura di Bootstrap (success, error, danger, ecc.)
    */
    function Message(text, color) {
        try {
            var n = $('#toast').dxToast('instance');

            if (color == undefined || color == null || color?.length == 0) {
                color = Costanti.NOTIFY_COLOR_INFO;
            }

            if (n != null && n != undefined) {
                $('#toast').dxToast('instance').option({
                    type: color,
                    message: decodeHTMLEntity(text),
                    visible: true,
                    displayTime: 5000,
                    width: '90vw',
                    animation: {
                        show: {
                            type: 'fade',
                            duration: 400,
                            from: 0,
                            to: 1,
                        },
                        hide: {
                            type: 'fade',
                            duration: 40,
                            to: 0
                        },
                    },
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    function GenericError(testo) {

        if (!(testo && testo.length > 0)) {
            testo = 'Errore generico';
        }
        Message(testo, Costanti.NOTIFY_COLOR_ERROR);
    }

    return {
        'Message': Message,
        'GenericError': GenericError
    }

})();


var Waiter = (function () {

    function Show(testo) {
        UpdateWaitPanel(true, testo);

        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function Hide(testo) {
        UpdateWaitPanel(false, testo);
        window.onscroll = function () { };
    }
    function UpdateWaitPanel(value, testo) {
        try {
            var div = $('#GenericLoadPanel');

            if (div && div.length > 0) {

                if (testo && testo.length > 0) {
                    div.dxLoadPanel('instance')?.option('message', testo);
                }
                else {
                    div.dxLoadPanel('instance')?.option('message', 'Caricamento in corso...');
                }

                div.dxLoadPanel('instance')?.option('visible', value);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    return {
        'Show': Show,
        'Hide': Hide
    }
})();



const DisableContextMenu = function (e) {
    try {
        if (e.target === 'header') e.items = null;

    } catch (error) {
        console.log(error);
    }
}

function GestisciApprovazioneCliente(idCliente, azione, Email, piva) {
    try {
        Waiter.Show();

        var panel = $('#GenericLoadPanel').dxLoadPanel('instance');

        var param = {
            id: idCliente,
            tipoAzione: azione,
            email: Email,
            partitaIva: piva
        };

        panel.option('message', 'Approvazione in corso...');
        CallServiceAsync('/User/GestisciApprovazioneCliente', param)
            .then((risp) => {
                if (risp && risp.Esito == Costanti.ESITO_OK) {

                    panel.option('message', 'Contattando ACG...');
                    CallServiceAsync('/User/GestisciUtenteACG', param)
                        .then((r) => {
                            if (r && r.Esito == Costanti.ESITO_OK) {

                                panel.option('message', 'Invio mail in corso...');
                                CallServiceAsync('/User/InviaMailApprovazione', param)
                                    .then((risp) => {
                                        Notify.Message(risp.ResponseText, risp.NotifyColor);

                                        panel.option('message', '');

                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 1500);
                                    })
                                    .catch((ex) => {
                                        console.log(ex);
                                        Notify.GenericError();
                                        Waiter.Hide();
                                    })
                            }
                            else {
                                Notify.GenericError('Errore durante l\'inserimento in ACG');
                                Waiter.Hide();
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1500);
                            }
                        })
                        .catch((ex) => {
                            console.log(ex);
                            Notify.GenericError();
                            Waiter.Hide();
                        })
                }
                else {
                    Notify.GenericError('Errore durante l\'approvazione');
                    Waiter.Hide();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Waiter.Hide();
                Notify.GenericError();
            });

    }
    catch (error) {
        console.log(error);
        Waiter.Hide();
    }
}

function InserisciCliente() {
    try {
        var formData = new FormData($('#fNuovoCliente')[0]);
        CallServiceFormDataAsync($('#fNuovoCliente').attr('action'), formData)
            .then(risp => {
                if (risp) {
                    Notify.Message(risp.ResponseText, risp.NotifyColor);

                    if (risp.Esito == Costanti.ESITO_OK) {
                        setTimeout(function () {
                            location.reload();
                        }, 1500);
                    }
                    else {
                        Waiter.Hide();
                    }
                }
                else {
                    Notify.GenericError('Errore durante il salvataggio');
                    Waiter.Hide();
                }
            })
            .catch(error => {
                console.log(error);
                Waiter.Hide();
            });
    }
    catch (error) {
        console.log(error);
        Waiter.Hide();;
    }
}

function ddlTipologie_ValueChanged(e) {
    try {

        if (!e.value) {
            e.value = 0;
        }

        var objd = $('#ddlSottotipologie');
        //console.log(e.component.option('selectedItem')?.SottoTipologie);
        if (objd && objd.length > 0) {
            objd.dxSelectBox('instance').getDataSource().reload();

            if (e.value == null || e.value == 0 || e.component.option('selectedItem')?.SottoTipologie == null) {
                objd.dxSelectBox('instance').option('disabled', true);
            }
            else {
                objd.dxSelectBox('instance').option('disabled', false);
            }
            objd.dxSelectBox('instance').option('value', null);
        }

        var file = $('#FileDaCaricare');
        if (file != null && file != undefined && file.length > 0) {

            var uploader = file.dxFileUploader('instance');

            if (uploader != null && uploader != undefined) {
                if (uploader.option('value') != null && uploader.option('value').length > 0) {

                    param = {
                        nomeDoc: uploader.option('value')[0].name,
                        dtypID: e.value,
                        dstyID: $('#ddlSottotipologie').dxSelectBox('instance').option('value')
                    };

                    var nomeUsato = CallService('/Documenti/CheckNomeDocumentoUsato', param);

                    if (nomeUsato.Esito == Costanti.ESITO_KO) {
                        Notify.Message(nomeUsato.ResponseText, nomeUsato.NotifyColor);
                        e.component.reset();
                    }
                    else {
                        if ($('#DocNomeFile').length > 0) {
                            $('#DocNomeFile').removeClass('is-invalid');
                            $('#DocNomeFile').val(file.name);
                            $('#DocNomeFile').attr('title', file.name);
                        }
                    }
                }
            }
        }

        if (e.value == null || e.value == 0) {
            e.component.option('value', 0);
        }

    }
    catch (ex) {
        console.log(ex);
    }
}

function ddlSottoTipologie_ValueChanged(e) {
    try {

        if (!e.value) {
            e.value = 0;
        }

        var objd = $('#ddlTipologie');
        var file = $('#FileDaCaricare');

        if (objd && objd.length > 0 && file != null && file != undefined && file.length > 0) {

            var uploader = file.dxFileUploader('instance');

            if (uploader != null && uploader != undefined) {
                if (uploader.option('value') != null && uploader.option('value').length > 0) {

                    param = {
                        nomeDoc: uploader.option('value')[0].name,
                        dtypID: objd.dxSelectBox('instance').option('value'),
                        dstyID: e.value
                    };

                    var nomeUsato = CallService('/Documenti/CheckNomeDocumentoUsato', param);

                    if (nomeUsato.Esito == Costanti.ESITO_KO) {
                        Notify.Message(nomeUsato.ResponseText, nomeUsato.NotifyColor);
                        e.component.reset();
                    }
                    else {
                        if ($('#DocNomeFile').length > 0) {
                            $('#DocNomeFile').removeClass('is-invalid');
                            $('#DocNomeFile').val(file.name);
                            $('#DocNomeFile').attr('title', file.name);
                        }
                    }
                }
            }
        }

        if (e.value == null || e.value == 0) {
            e.component.option('value', 0);
        }

        ToggleRiferimentoSKU(e.value);

    }
    catch (ex) {
        console.log(ex);
    }
}

/// Abilita il campo Codice Prodotto (SKU) solo per la sotto tipologia "Supporti Marketing",
/// altrimenti lo nasconde e lo svuota. Autore: Claude
function ToggleRiferimentoSKU(dstyId) {
    try {

        var campo = $('#DocRiferimentoSKU');

        if (campo.length == 0) {
            return;
        }

        var abilitato = parseInt(dstyId) === Costanti.TIPO_SOTTODOCUMENTO_SUPPORTI_MARKETING;

        // .hide()/.show() e non la classe 'hidden': su queste colonne 'display' può essere
        // impostato da classi Bootstrap con !important, che vincerebbero sulla classe
        if (abilitato) {
            $('.rigaRiferimentoSKU').show();
        }
        else {
            $('.rigaRiferimentoSKU').hide();
        }

        campo.prop('disabled', !abilitato);

        if (!abilitato) {
            campo.removeClass('is-invalid');
            campo.val('');
        }

    }
    catch (ex) {
        console.error(ex);
    }
}

function AllineaNomeFileCheckedChange(elem) {
    try {

        if ($('#ddlTipologie') && $('#ddlTipologie').length > 0) {
            var ddlTipoDoc = $('#ddlTipologie').dxSelectBox('instance');

            if (!ddlTipoDoc.option('value')) {
                ddlTipoDoc.option('isValid', true);
            }
        }

        $('#FileDaCaricare').dxFileUploader('instance').option('isValid', true);

        $('#checkFile').addClass('hidden');

        $('form#fImportDocument :input').each(function (index, value) {
            $(this).removeClass('is-invalid');
        });

        if (elem.checked) {
            $('#Documento_DOCU_FileName').removeAttr('required');
        }
        else {
            $('#Documento_DOCU_FileName').prop('required', true);
        }


    } catch (err) {
        console.log(err);
    }
}

function FileDaCaricareFilesUploaded(e) {
    try {
        //if ($('#AllineaFile')[0].checked == true) {
        var file = e.value[0];

        if (file != null && file != undefined) {
            param = {
                nomeDoc: file.name,
                dtypID: $('#ddlTipologie').dxSelectBox('instance')?.option('value'),
                dstyID: $('#ddlSottotipologie').dxSelectBox('instance')?.option('value'),
                docuId: parseInt($('#Documento_DOCU_Id').val()) || 0
            };

            var nomeUsato = CallService('/Documenti/CheckNomeDocumentoUsato', param);

            if (nomeUsato.Esito == Costanti.ESITO_KO) {
                Notify.Message(nomeUsato.ResponseText, nomeUsato.NotifyColor);
                e.component.reset();
            }
            else {
                $('#DocNomeFile').removeClass('is-invalid');
                $('#DocNomeFile').val(file.name);
                $('#DocNomeFile').attr('title', file.name);
            }
        }
        //}

    } catch (err) {
        console.log(err);
    }
}

function ValidateNewDocProdotto() {
    try {
        Waiter.Show();
        var risp = true;
        //var idDoc = parseInt($('#IdDocumento').html());

        if ($('#ddlTipologie') && $('#ddlTipologie').length > 0) {
            var ddlTipoDoc = $('#ddlTipologie').dxSelectBox('instance');

            if (!ddlTipoDoc.option('value') || ddlTipoDoc.option('value') == 0) {
                ddlTipoDoc.option('isValid', false);
                risp = false;
            }
            else {
                ddlTipoDoc.option('isValid', true);
            }
        }

        $('form#fImportDocument :input').each(function (index, value) {
            $(this).removeClass('is-invalid');
            if ($(this).attr('required') && ($(this)[0].disabled == false || !$(this).attr('disabled'))) {
                if (!$(this).val()) {
                    $(this).addClass('is-invalid');
                    risp = false;
                }
            }
            else {
                $(this).removeClass('is-invalid');
            }
        });

        if ($('#FileDaCaricare').dxFileUploader('instance').option('value').length == 0) {
            var nome = $('#DocNomeFile');
            if (nome && nome.length > 0) {
                nome.removeClass('is-invalid');
                if (nome.val()?.trim()?.length == 0) {
                    nome.addClass('is-invalid');
                    risp = false;
                }
            }
            else {
                $('#checkFile').removeClass('hidden');
                risp = false;
            }
        }
        else {
            $('#checkFile').addClass('hidden');
        }



        //if (idDoc == 0) {
        //    if ($('#AllineaFile')[0].checked == false) {

        //        if ($('#Documento_DOCU_FileName').val()?.trim()?.length > 0) {
        //            param = {
        //                nomeDoc: $('#Documento_DOCU_FileName').val()?.trim()
        //            };

        //            var nomeUsato = CallService('/Documenti/CheckNomeDocumentoUsato', param);

        //            if (nomeUsato.Esito == Costanti.ESITO_KO) {
        //                Notify.Message(nomeUsato.ResponseText, nomeUsato.NotifyColor);
        //                risp = false;
        //                $('#Documento_DOCU_FileName').addClass('is-invalid');
        //            }
        //            else {
        //                $('#Documento_DOCU_FileName').removeClass('is-invalid');
        //            }
        //        }
        //    }
        //    else {
        //        if ($('#FileDaCaricare').dxFileUploader('instance').option('value').length == 0) {
        //            $('#checkFile').removeClass('hidden');
        //            risp = false;
        //        }
        //        else {
        //            $('#checkFile').addClass('hidden');
        //        }
        //    }
        //}

        //if ($('#AllineaFile')[0].checked == true) {
        //    if ($('#FileDaCaricare').dxFileUploader('instance').option('value').length == 0) {
        //        $('#checkFile').removeClass('hidden');
        //        risp = false;
        //    }
        //    else {
        //        $('#checkFile').addClass('hidden');
        //    }
        //}
        //else {
        //    var nome = $('#DocNomeFile');
        //    if (nome && nome.length > 0) {
        //        nome.removeClass('is-invalid');
        //        if (nome.val()?.trim()?.length == 0) {
        //            nome.addClass('is-invalid');
        //            risp = false;
        //        }
        //    }
        //}
    }
    catch (error) {
        console.log(error);
        Waiter.Hide();
        return false;
    }

    if (risp == false) {
        Waiter.Hide();
    }
    return risp;
}

function ValidateNewVideo() {
    try {

        var urlVideo = $('#DocUrlVideo');

        if (urlVideo && urlVideo.length > 0) {
            if (urlVideo.val() && urlVideo.val().trim().length > 0) {
                urlVideo.removeClass('is-invalid');
                return true;
            }
            else {
                urlVideo.addClass('is-invalid');
            }
        }

    } catch (err) {
        console.log(err);
    }

    return false;
}

function ValidateNewPaginaCatalogo() {
    var risp = true;
    try {

        //if ($('#AllineaFile')[0].checked == true) {
        //    if ($('#FileDaCaricare').dxFileUploader('instance').option('value').length == 0) {
        //        $('#checkFile').removeClass('hidden');
        //        risp = false;
        //    }
        //    else {
        //        $('#checkFile').addClass('hidden');
        //    }
        //}
        //else {
        //    var nome = $('#DocNomeFile');
        //    if (nome && nome.length > 0) {
        //        nome.removeClass('is-invalid');

        //        if (nome.val()?.trim()?.length == 0) {
        //            nome.addClass('is-invalid');
        //            risp = false;
        //        }
        //    }
        //}

        var nome = $('#DocNomeFile');
        if (nome && nome.length > 0) {
            nome.removeClass('is-invalid');
            if (nome.val()?.trim()?.length == 0) {
                nome.addClass('is-invalid');
                risp = false;
            }
        }

    } catch (err) {
        console.log(err);
        risp = false
    }

    return risp;
}

//function CheckFormImmagine(idform) {
//    try {

//        var inputs = $('form#fImmagine' + idform + ' :input[type='radio']');
//        var testo = $('#txt' + idform);

//        var cont = 0;
//        inputs.each(function (index, item) {
//            if (item.checked == true) {
//                cont++;
//            }
//        })

//        if (cont > 0) {
//            testo.removeClass('d-flex');
//            return true
//        }
//        else {
//            testo.addClass('d-flex');
//            return false;
//        }

//    } catch (error) {
//        console.log(error);
//        return false;
//    }
//}

/**
 * Consente di selezionare solo le ultime categorie
 */
function TreeListCategorieProdotto_cellPrepared(e) {
    try {

        if (e && e.row && e.row.rowType == 'data') {
            if (e.row.isSelected == false) {
                if (e.row.node.hasChildren == true) {
                    var element = e.cellElement[0];
                    var checkbox = element.querySelector('.dx-select-checkbox');
                    checkbox.style.display = 'none';
                    var icona = element.querySelector('.dx-treelist-icon-container');
                    icona.style.paddingRight = '0px';
                }
            }
            else {
                //console.log(e);
            }
        }

    } catch (err) {
        console.log(err);
    }
}

var espandi = true;
/**
 * Espande tutti i padri di una lista di nodi, data la key del nodo
 */
function TreeListCategorieProdotto_contentReadyInner(e, list) {
    try {

        //console.log(list);
        if (espandi == true) {
            list.forEach(function (value, index) {
                var nodo = e.component.getNodeByKey(value);
                if (nodo) {
                    while (nodo.parent) {
                        if (nodo.parent.key > 0) {
                            e.component.expandRow(nodo.parent.key)
                            //console.log('parent: ' + nodo.parent.key)
                            //console.log('nodo.key: ' + nodo.key)
                        }
                        nodo = nodo.parent;
                    }
                }
            })
        }

        espandi = false;

    } catch (err) {
        console.log(err);
    }
}

function TreeListCategorieProdotto_KeyDown(e) {
    try {

        console.log(e);

    } catch (ex) {
        console.log(ex);
    }
}

var OverriddenForms = new Map();
// Autore: Claude
// Aggancia un handler di submit, in event delegation sul document, ai form con id che inizia per `elemId`.
// Il delegato sopravvive ai re-render di DevExtreme (paginazione/filtro/ordinamento) che ricreano i nodi DOM.
function OverrideFormSubmit(elemId) {
    try {
        if (OverriddenForms.has(elemId)) {
            return;
        }
        OverriddenForms.set(elemId, true);

        $(document).on('submit', 'form[id^=' + elemId + ']', function (e) {
            try {
                e.preventDefault();

                Waiter.Show();

                var form = $(this);
                var formData = new FormData(this);

                CallServiceFormDataAsync('/Documenti/EsistenzaDocumento', formData)
                    .then(result => {
                        if (result && result.Esito == Costanti.ESITO_OK) {
                            window.open(form.attr('action') + '/' + formData.get('Doc_id') + '/' + formData.get('nomeFile'), '_blank');
                        }
                        else {
                            Notify.Message('Il documento non \xE8 stato trovato.', Costanti.NOTIFY_COLOR_ERROR);
                        }
                        Waiter.Hide();
                    })
                    .catch(error => {
                        console.error(error);
                        Waiter.Hide();
                    });
            } catch (ex) {
                console.error(ex);
                Waiter.Hide();
            }
        });
    } catch (err) {
        console.error(err);
    }
}

/**
 * Invia una mail di verifica dell'indirizzo email di un cliente
 * @param {string} IdUser
 * @param {string} Email
 * @param {string} RagioneSociale
 */
function InviaMailVerifica(IdUser, Email, RagioneSociale) {
    try {

        if (IdUser && IdUser > 0 && Email && IsEmail(Email) == true && RagioneSociale) {
            Waiter.Show();

            var params = {
                iduser: IdUser,
                email: Email,
                ragSoc: RagioneSociale
            };

            CallServiceAsync('/User/InviaMailVerifica', params)
                .then(risp => {
                    Waiter.Hide();
                    if (risp) {
                        Notify.Message(risp.ResponseText, risp.NotifyColor);
                    }

                })
                .catch(error => {
                    Waiter.Hide();
                    Notify.GenericError();
                    console.log(error);
                })

        }
        else {
            Waiter.Hide();
            Notify.GenericError();
        }

    } catch (err) {
        Waiter.Hide();
        console.log(err);
    }
}


/**
 * Invia una mail di confermata registrazione di un cliente
 * @param {string} Email la mail a cui mandare l'email
 */
function InviaMailRegistrazione(Email) {
    try {

        if (Email && IsEmail(Email)) {
            Waiter.Show();

            var params = {
                email: Email
            };

            CallServiceAsync('/User/InviaMailRegistrazione', params)
                .then(risp => {
                    Waiter.Hide();
                    if (risp) {
                        Notify.Message(risp.ResponseText, risp.NotifyColor);
                    }

                })
                .catch(error => {
                    Waiter.Hide();
                    Notify.GenericError();
                    console.log(error);
                })

        }
        else {
            Waiter.Hide();
            Notify.GenericError();
        }

    } catch (err) {
        Waiter.Hide();
        console.log(err);
    }
}

function gridContainerRowPrepared(e) {
    try {

        if (e && e.data && e.rowType == 'data') {
            //console.log(e);
            if (e.data.Visibile == false) {
                $('#DocVis' + e.data.Id).hide();
            }
            else {
                $('#DocNoVis' + e.data.Id).hide();
            }

            //if (e.cells[0].column?.type == 'selection') {
            //    if (listaIdDocsNoVideoEPagine != undefined && listaIdDocsNoVideoEPagine?.length > 0) {
            //        if (listaIdDocsNoVideoEPagine.includes(e.data.Id)) {
            //            e.cells[0].column.visible = false;
            //        }
            //    }
            //}

        }

    } catch (err) {
        console.log(err);
    }
}

function GridPopup_EditorPreparing(e) {
    try {

        if (e.type == 'selection' && e.parentType == 'dataRow') {
            console.log(e);
            if (listaIdDocsNoVideoEPagine != undefined && listaIdDocsNoVideoEPagine?.length > 0) {
                if (listaIdDocsNoVideoEPagine.includes(e.row.data.Id)) {
                    e.visible = false;
                }
            }
            console.log(e);
        }

    } catch (ex) {
        console.log(ex);
    }
}

function ExportProdottiFull() {
    try {

        Waiter.Show();

        CallServiceAsyncGetFile('/Documenti/EsportaProdottiFull')
            .then((response) => {
                if (response.Esito == Costanti.ESITO_KO) {
                    throw new Error('Errore nella risposta del server');
                    Notify.GenericError();
                }

                var blob = new Blob([s2ab(atob(response.File))], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                });

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = DateTimeNow() + '_ExportProdottiFull.xlsx';
                link.click();


                Waiter.Hide();
            })
            .catch((error) => {
                console.log(error);
                Waiter.Hide();
            });

    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function ExportManualiFull() {
    try {

        Waiter.Show();

        CallServiceAsyncGetFile('/Documenti/EsportaManuali')
            .then((response) => {
                if (response.Esito == Costanti.ESITO_KO) {
                    Notify.GenericError();
                }
                else {
                    var blob = new Blob([s2ab(atob(response.File))], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                    });

                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'ExportManuali.xlsx';
                    link.click();
                }

                Waiter.Hide();
            })
            .catch((error) => {
                console.log(error);
                Waiter.Hide();
            });

    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
    return false;
}

// Autore: Claude
function ExportConfezionamentiExcel() {
    try {
        Waiter.Show();

        CallServiceAsyncGetFile('/Confezionamento/ExportConfezionamentiExcel')
            .then((response) => {
                if (response.Esito == Costanti.ESITO_KO) {
                    throw new Error('Errore nella risposta del server');
                }

                var blob = new Blob([s2ab(atob(response.File))], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                });

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = DateTimeNow() + '_Confezionamenti.xlsx';
                link.click();

                Waiter.Hide();
            })
            .catch((error) => {
                console.log(error);
                Notify.GenericError();
                Waiter.Hide();
            });

    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

function DateTimeNow() {
    const now = new Date();

    const pad = (num, size) => num.toString().padStart(size, '0');

    const day = pad(now.getDate(), 2);
    const month = pad(now.getMonth() + 1, 2); // I mesi in JavaScript sono indicizzati da 0
    const year = now.getFullYear();
    const hours = pad(now.getHours(), 2);
    const minutes = pad(now.getMinutes(), 2);
    const seconds = pad(now.getSeconds(), 2);
    const milliseconds = pad(now.getMilliseconds(), 5); // JavaScript restituisce fino a 3 cifre, dobbiamo aggiungere padding

    return `${day}${month}${year}${hours}${minutes}${seconds}${milliseconds}`;
}

function PRCOValidation(btn) {
    try {
        var form = $(btn).closest('form');

        if (form && form.length > 0) {
            var nome = $('#' + form.attr('id') + ' textarea#PRCO_Nome');

            if (nome && nome.length > 0) {
                if (nome.val().trim().length > 0) {
                    if (confirm('Salvare le modifiche?')) {
                        Waiter.Show();
                        return true;
                    }
                }
                else {
                    nome.addClass('is-invalid');
                    window.scrollTo(0, 150);
                }
            }
        }
        return false;

    } catch (err) {
        console.log(err);
        return false;
    }
}

function DocumentoAggiorna(e, docID) {
    if (docID > 0) {
        var p = {};
        p.Doc_id = String(docID);
        Waiter.Show();
        CallServiceAsync('/Documenti/DatiDocumento', p)
            .then(r => {
                if (r != null) {
                    try {
                        var instance = $('#accordion-container').dxAccordion('instance');
                        var items = instance.option('items');

                        items[2].title = r[0];
                        items[3].title = r[1];

                        instance.repaint();
                    }
                    catch (err) {
                        console.log(err);
                    }
                    try {
                        $('textarea#ListaCodici').text(r[2]);
                    }
                    catch (err) {
                        console.log(err);
                    }
                }
                else {
                    console.log('r is ' + typeof (r));
                }

                Waiter.Hide();
            })
            .catch(error => {
                console.log(error);
                Waiter.Hide();
            })
            .finally(function () {
                DataGridCommonSettings();
            })
    }
}

function RefreshListaCodici(e) {
    try {
        if (e.addedItems[0] && e.addedItems[0].title.includes('Associa') == true) {
            var docID = parseInt($('#IdDocumento').html());
            DocumentoAggiorna(e, docID);
        }
    }
    catch (err) {
        console.log(err);
    }
    return true;
}

function gridContainerXSelectionChanged(e) {
    try {
        var IdGriglia = e.element[0].id;

        $('#BtnRimuoviAssociatiSelected_' + IdGriglia).addClass('hidden');
        $('#BtnRendiVisibileAssociatiSelected_' + IdGriglia).addClass('hidden');
        $('#BtnNascondiAssociatiSelected_' + IdGriglia).addClass('hidden');
        $('#BtnAssociaSelected_' + IdGriglia).addClass('hidden');

        if (IdGriglia.toLowerCase().includes('associati')) {
            if (e.selectedRowKeys.length > 0) {
                $('#BtnRimuoviAssociatiSelected_' + IdGriglia).removeClass('hidden');
                $('#BtnNascondiAssociatiSelected_' + IdGriglia).removeClass('hidden');
            }
        }
        else if (IdGriglia.toLowerCase().includes('nonvisibili')) {
            if (e.selectedRowKeys.length > 0) {
                $('#BtnRimuoviAssociatiSelected_' + IdGriglia).removeClass('hidden');
                $('#BtnRendiVisibileAssociatiSelected_' + IdGriglia).removeClass('hidden');
            }
        }
        else if (IdGriglia.toLowerCase().includes('ricercati')) {
            if (e.selectedRowKeys.length > 0) {
                $('#BtnAssociaSelected_' + IdGriglia).removeClass('hidden');
            }
        }

    } catch (err) {
        console.log(err);
    }
}

function BtnRimuoviAssociatiSelected_Click(idGriglia) {
    try {

        var instance = $('#' + idGriglia).dxDataGrid('instance');

        if (instance) {

            var selectedKeys = instance.getSelectedRowKeys();
            var idDocumento = parseInt($('#IdDocumento').html());
            var p = {
                docID: idDocumento,
                skuList: selectedKeys.join(',')
            };

            Waiter.Show();
            CallServiceAsync('/Documenti/RimuoviBulk', p)
                .then(r => {
                    if (r) {
                        DocumentoAggiorna(null, idDocumento);
                    }
                    Waiter.Hide();
                })
                .catch(error => {
                    console.log(error);
                    Waiter.Hide();
                })
        }


    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function BtnNascondiAssociatiSelected_Click(idGriglia) {
    try {

        var instance = $('#' + idGriglia).dxDataGrid('instance');

        if (instance) {

            var selectedKeys = instance.getSelectedRowKeys();
            var idDocumento = parseInt($('#IdDocumento').html());
            var p = {
                docID: idDocumento,
                skuList: selectedKeys.join(',')
            };

            Waiter.Show();
            CallServiceAsync('/Documenti/DocumentoNonVisibileBulk', p)
                .then(r => {
                    if (r) {
                        DocumentoAggiorna(null, idDocumento);
                    }
                    Waiter.Hide();
                })
                .catch(error => {
                    console.log(error);
                    Waiter.Hide();
                })
        }


    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function BtnRendiVisibileAssociatiSelected_Click(idGriglia) {
    try {

        var instance = $('#' + idGriglia).dxDataGrid('instance');

        if (instance) {

            var selectedKeys = instance.getSelectedRowKeys();
            var idDocumento = parseInt($('#IdDocumento').html());
            var p = {
                docID: idDocumento,
                skuList: selectedKeys.join(',')
            };

            Waiter.Show();
            CallServiceAsync('/Documenti/DocumentoVisibileBulk', p)
                .then(r => {
                    if (r) {
                        DocumentoAggiorna(null, idDocumento);
                    }
                    Waiter.Hide();
                })
                .catch(error => {
                    console.log(error);
                    Waiter.Hide();
                })
        }


    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function BtnAssociaSelected_Click(idGriglia) {
    try {

        var instance = $('#' + idGriglia).dxDataGrid('instance');

        if (instance) {

            var selectedKeys = instance.getSelectedRowKeys();
            var idDocumento = parseInt($('#IdDocumento').html());
            var p = {
                docID: idDocumento,
                skuList: selectedKeys.join(',')
            };

            Waiter.Show();
            CallServiceAsync('/Documenti/AssociaBulk', p)
                .then(r => {
                    if (r) {
                        DocumentoAggiorna(null, idDocumento);
                    }
                    Waiter.Hide();
                })
                .catch(error => {
                    console.log(error);
                    Waiter.Hide();
                })
        }


    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

function DocumentoNonVisibile(sku) {
    try {
        Waiter.Show();

        var p = {
            sku: sku,
            Doc_id: parseInt($('#IdDocumento').html())
        }

        CallServiceAsync('/Documenti/DocumentoNonVisibile', p)
            .then((r) => {
                if (r) {
                    Waiter.Hide();
                    Notify.Message('Prodotto ' + sku + ' associato', 'info');
                    DocumentoAggiorna(null, parseInt($('#IdDocumento').html()));
                    $('#gridContainerXRicercati').dxDataGrid('instance').getDataSource().reload();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Waiter.Hide();
            })
    } catch (ex) {
        console.log(ex);
    }
}

function DocumentoVisibile(sku) {
    try {
        Waiter.Show();

        var p = {
            sku: sku,
            Doc_id: parseInt($('#IdDocumento').html())
        }

        CallServiceAsync('/Documenti/DocumentoVisibile', p)
            .then((r) => {
                if (r) {
                    Waiter.Hide();
                    Notify.Message('Prodotto ' + sku + ' associato', 'info');
                    DocumentoAggiorna(null, parseInt($('#IdDocumento').html()));
                    $('#gridContainerXRicercati').dxDataGrid('instance').getDataSource().reload();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Waiter.Hide();
            })
    } catch (ex) {
        console.log(ex);
    }
}

function DocumentoAssocia(sku) {
    try {
        Waiter.Show();

        var p = {
            sku: sku,
            Doc_id: parseInt($('#IdDocumento').html())
        }

        CallServiceAsync('/Documenti/Associa', p)
            .then((r) => {
                if (r) {
                    Waiter.Hide();
                    Notify.Message('Prodotto ' + sku + ' associato', 'info');
                    DocumentoAggiorna(null, parseInt($('#IdDocumento').html()));
                    $('#gridContainerXRicercati').dxDataGrid('instance').getDataSource().reload();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Waiter.Hide();
            })
    } catch (ex) {
        console.log(ex);
    }
}

function DocumentoRimuovi(sku) {
    try {
        Waiter.Show();

        var p = {
            sku: sku,
            Doc_id: parseInt($('#IdDocumento').html())
        }

        CallServiceAsync('/Documenti/Rimuovi', p)
            .then((r) => {
                if (r) {
                    Waiter.Hide();
                    Notify.Message('Prodotto ' + sku + ' associato', 'info');
                    DocumentoAggiorna(null, parseInt($('#IdDocumento').html()));
                    $('#gridContainerXRicercati').dxDataGrid('instance').getDataSource().reload();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Waiter.Hide();
            })
    } catch (ex) {
        console.log(ex);
    }
}

function BtnFormDatiProdotti_Click() {
    try {
        var valid = true;

        var codSku = $('#codiceProdotto');
        var sku = '';
        var nomeProd = $('#nomeProdotto');
        //var prezzoProd = $('#prezzoProdotto');
        //var ivaProd = $('#ivaProdotto');
        //var scontoProd = $('#scontoProdotto');
        var minimoProd = $('#minimoProdotto');

        var toCheck = [
            codSku,
            nomeProd,
            //prezzoProd,
            //ivaProd,
            //scontoProd,
            minimoProd
        ];

        toCheck.forEach((item, index) => {
            if (item.val()?.length > 0) {
                item.removeClass('is-invalid');
            }
            else {
                item.addClass('is-invalid');
                valid = false;
            }
        })


        if (valid == true) {

            var tit = $('#titolo');
            if (tit && tit.length > 0 && tit.html().toLowerCase().includes('nuovo')) {

                var p = {
                    sku: codSku.val()
                }
                Waiter.Show();

                var r = CallService('/Product/GetProduct', p);

                if (r && r != null && r != undefined && r.PROD_sku.length > 0) {
                    alert('Il prodotto ' + codSku.val() + ' esiste già!');
                }
                else {
                    if (confirm('Salvare le modifiche?') == true) {

                        return true;
                    }
                }
                Waiter.Hide();
                return false;
            }
            else {
                if (confirm('Salvare le modifiche?') == true) {
                    Waiter.Show()
                    return true;
                }
                else {
                    return false;
                }
            }

        }
        else {
            return false;
        }

    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
        return false;
    }
}

function TreeListCategorie_RowClick(e) {
    console.log(e.event.target);

    if (e.event.target.localName.toLowerCase() != 'span') {
        var selectedRows = e.component.getSelectedRowKeys();

        if (e.node.hasChildren == true) {
            e.isExpanded ? e.component.collapseRow(e.key) : e.component.expandRow(e.key);
        }
        else {

            if (selectedRows.includes(e.key)) {
                var index = selectedRows.indexOf(e.key);
                if (index !== -1) {
                    selectedRows.splice(index, 1);
                }
            }
            else {
                selectedRows.push(e.key);
            }

            e.component.selectRows(selectedRows);
        }
    }
}

function FileDaCaricareImmagineProdotto_ValueChanged(e) {
    try {

        if (e && e.value && e.value.length > 0 && e.value[0]) {
            var dati = e.value[0];

            if (!e.component.option('allowedFileExtensions').includes('.' + dati.type.split('/')[1])) {
                var bottone = $('#' + $(e.element).closest('form')[0].id + ' button');
                bottone.prop('disabled', true);
                bottone.prop('title', 'Estensione file non consentita!');

                var messaggio = $('#' + e.element[0].id + ' .dx-fileuploader-file-status-message');

                if (messaggio && messaggio.length > 0) {
                    messaggio[0].style.color = 'Red !important';
                }

            }
            else {
                var bottone = $('#' + $(e.element).closest('form')[0].id + ' button');
                bottone.prop('disabled', false);
                bottone.prop('title', '');

                var messaggio = $('#' + e.element[0].id + ' .dx-fileuploader-file-status-message');

                if (messaggio && messaggio.length > 0) {
                    messaggio[0].style.color = '';
                }
            }
        }

    } catch (err) {
        console.log(err);
    }
}

function popupRicercaDocumenti_ContentReady(e) {
    try {

        $('#fSearchDocumenti').submit((e) => {
            e.preventDefault();

            var params = {
                model: {
                    ParamRicerca: {
                        DTYP_Id: $('#ddlTipologie').dxSelectBox('instance').option('value'),
                        DSTY_Id: $('#ddlSottotipologie').dxSelectBox('instance').option('value'),
                        LING_LCID: $('#ddlLingue').dxSelectBox('instance').option('value'),
                        FileName: $('#ParamRicerca_FileName').val(),
                        Revisione: $('#ParamRicerca_Revisione').val(),
                        Note: $('#ParamRicerca_Note').val(),
                        sku: $('#ParamRicerca_sku').val(),
                        Visibile: $('#ParamRicerca_Visibile')[0].checked,
                        NonVisibile: $('#ParamRicerca_NonVisibile')[0].checked,
                        SenzaProdotti: $('#ParamRicerca_SenzaProdotti')[0].checked,
                        Presente: $('#ParamRicerca_Presente')[0].checked,
                        NonPresente: $('#ParamRicerca_NonPresente')[0].checked
                    },
                    IsPopup: true
                }
            };

            Waiter.Show();

            $.ajax({
                url: $(e.target).attr('action'),
                type: 'POST',
                data: params,
                DataType: 'json',
                success: function (data) {
                    $('#popupRicercaDocContent').html(data);
                    Waiter.Hide();
                },
                error: function (xhr, status, error) {
                    console.log(xhr);
                    console.log(status);
                    console.log(error);
                    Waiter.Hide();
                },
                complete: (xhr, status) => {
                    Waiter.Hide();

                    setTimeout(() => {
                        DataGridCommonSettings();
                    }, 100);
                }
            })

            return false;
        })

    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
    }
}

function btnDocumentiSelezionati_Click(idGriglia) {
    try {

        var grid = $('#' + idGriglia).dxDataGrid('instance');
        var sku = $('#titolo').html()?.split(':')[1]?.trim();

        if (grid != null && sku?.length > 0) {
            var selectedKeys = grid.getSelectedRowKeys();

            if (selectedKeys.length > 0) {

                var params = {
                    docIDList: selectedKeys.map((item) => { return item.Id }),
                    sku: sku
                }
                Waiter.Show();

                CallServiceAsync('/Documenti/AssociaDocumentiBulkAProdotto', params)
                    .then((r) => {
                        if (r == true) {
                            Notify.Message('Dati salvati correttamente', Costanti.NOTIFY_COLOR_SUCCESS);
                            window.location.href = '/Product/Visualizza?prodSku=' + sku + '&sezione=4';
                        }
                        else {
                            Notify.GenericError();
                        }
                    })
                    .catch((ex) => {
                        console.log(ex);
                    })
                    .complete(() => {
                        Waiter.Hide();
                    })
            }
            else {
                Notify.Message('Selezionare almeno una riga');
            }
        }

    } catch (ex) {
        console.log(ex);
    }
}

function SalvaTutteLeLingue() {
    try {

        if (confirm('Salvare le modifiche?')) {
            var tabPanel = $('#TabLingueProdotto').dxTabPanel('instance');

            if (tabPanel != undefined) {

                var index = tabPanel.option('selectedIndex');
                var sku = '';

                tabPanel.option('selectedIndex', 0);
                tabPanel.option('selectedIndex', 1);
                tabPanel.option('selectedIndex', 2);

                tabPanel.option('selectedIndex', index);

                var dati = [];
                var valid = true;

                $('[id^=formPRCO_]').each((index, item) => {

                    var nome = $('#' + item.id + ' #PRCO_Nome').val();

                    if (nome.trim().length == 0) {
                        Notify.Message('Per salvare i dati bisogna compilare tutti i campi Nome', Costanti.NOTIFY_COLOR_ERROR);
                        $('#' + item.id + ' #PRCO_Nome').addClass('is-invalid');
                        valid = false;
                    }

                    sku = $('#' + item.id + ' #PRCO_PROD_sku').val();

                    dati[index] = {
                        PRCO_id: $('#' + item.id + ' #PRCO_id').val(),
                        PRCO_PROD_sku: sku,
                        PRCO_lcid: $('#' + item.id + ' #PRCO_lcid').val(),
                        PRCO_Nome: nome
                    };

                    dati[index].PRCO_descrizione = $('#' + item.id + ' #PRCO_descrizione_' + dati[index].PRCO_lcid).dxHtmlEditor('instance').option('value');
                    dati[index].PRCO_CaratteristicheTecniche = $('#' + item.id + ' #PRCO_CaratteristicheTecniche_' + dati[index].PRCO_lcid).dxHtmlEditor('instance').option('value');
                    dati[index].PRCO_DotazioneStandard = $('#' + item.id + ' #PRCO_DotazioneStandard_' + dati[index].PRCO_lcid).dxHtmlEditor('instance').option('value');
                })

                if (valid == true) {
                    var params = {
                        dati
                    };
                    Waiter.Show();

                    CallServiceAsync('/Product/UpdateProdottiContenutiJS', params)
                        .then((r) => {

                            if (r.filter((item) => { return item == false }).length == r.length) {
                                Notify.Message('Errore durante il salvataggio', Costanti.NOTIFY_COLOR_ERROR);
                                Waiter.Hide();
                            }
                            else if (r.filter((item) => { return item == false }).length == 0) {
                                Notify.Message('Dati salvati correttamente', Costanti.NOTIFY_COLOR_SUCCESS);
                            }
                            else {
                                Notify.Message('Errore, non tutti i dati sono stati salvati', Costanti.NOTIFY_COLOR_WARNING);
                            }

                            //tabPanel.getDataSource().reload();

                            //var title = 'Lingue ' + r.filter((item) => { return item == true }).length;
                            //$('#accordion-container').dxAccordion('instance').option('items').filter((item) => { return item.title.toLowerCase().includes('lingue') })[0].title = title;
                            //$('#accordion-container').dxAccordion('instance').repaint();

                            setTimeout(() => {
                                window.location.href = '/Product/Visualizza?prodSku=' + sku + '&sezione=1';
                            }, 500);
                        })
                        .catch((ex) => {
                            console.log(ex);
                            tabPanel.getDataSource().reload();
                            Waiter.Hide();
                        });
                }
            }
        }
    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
    }
}

function SalvaTutteLeLingueConfezionamento(confID) {
    var grid = $('#gridContainer').dxDataGrid('instance');
    try {

        if (confirm('Salvare i dati di tutte le lingue?')) {

            var tabPanel = $('#tabpanel-container').dxTabPanel('instance');

            if (tabPanel != undefined) {
                var index = tabPanel.option('selectedIndex');

                tabPanel.option('selectedIndex', 0);
                tabPanel.option('selectedIndex', 1);
                tabPanel.option('selectedIndex', 2);

                tabPanel.option('selectedIndex', index);

                var dati = [];
                var valid = true;

                $('[id^=formCONF_]').each((index, item) => {

                    var nome = $('#' + item.id + ' #CNLI_Nome').val();

                    if (nome.trim().length == 0) {
                        Notify.Message('Per salvare i dati bisogna compilare tutti i campi Nome', Costanti.NOTIFY_COLOR_ERROR);
                        $('#' + item.id + ' #CNLI_Nome').addClass('is-invalid');
                        valid = false;
                    }

                    dati[index] = {
                        CNLI_id: $('#' + item.id + ' #CNLI_id').val(),
                        CNLI_CONF_id: $('#' + item.id + ' #CNLI_CONF_id').val(),
                        CNLI_LING_LCID: $('#' + item.id + ' #CNLI_LING_LCID').val(),
                        CNLI_Nome: nome
                    };
                });

                console.log(dati);

                if (valid == true) {
                    var params = {
                        dati
                    };
                    Waiter.Show();

                    CallServiceAsync('/Confezionamento/UpdateConfezionamentoLingueBulk', params)
                        .then((r) => {

                            if (r.filter((item) => { return item == false }).length == r.length) {
                                Notify.Message('Errore durante il salvataggio', Costanti.NOTIFY_COLOR_ERROR);
                            }
                            else if (r.filter((item) => { return item == false }).length == 0) {
                                Notify.Message('Dati salvati correttamente', Costanti.NOTIFY_COLOR_SUCCESS);
                            }
                            else {
                                Notify.Message('Errore, non tutti i dati sono stati salvati', Costanti.NOTIFY_COLOR_WARNING);
                            }

                            grid.getDataSource().reload();
                            grid.collapseAll(-1);

                            Waiter.Hide();
                        })
                        .catch((ex) => {
                            console.log(ex);
                            grid.getDataSource().reload();
                            Waiter.Hide();
                        });
                }
            }
        }

    } catch (ex) {
        console.log(ex);
        grid.Hide();
    }
}
function TabLingueProdottoTitleTemplate(itemData, itemIndex, itemElement) {
    try {

        itemElement.append($('<span>').text(itemData.DescrizioneLingua));

        if (itemData.PRCO_Nome.length > 0) {
            itemElement.append($('<span>').text('check_circle').addClass('material-symbols-outlined text-success'));
        }
        else {
            itemElement.append($('<span>').text('cancel').addClass('material-symbols-outlined text-danger'));
        }

    } catch (ex) {
        console.log(ex);
    }
}


function DocumentoProdottoElimina(docID, gridID, nonVideo) {
    try {
        // Autore: Claude
        if (!confirm('Sei sicuro di voler eliminare questo documento?')) {
            return;
        }

        Waiter.Show();

        CallServiceAsync('/Documenti/GetSkuAssociati', { IdDocumento: docID })
            .then((r) => {

                var conferma = null;

                if (r && r.length > 0) {
                    conferma = confirm('Il documento è associato a ' + r.length + ' prodotti. Eliminandolo verranno rimosse tutte le associazioni. Continuare?');
                }

                if (conferma == true || conferma == null) {
                    var cancellaFileFisico = false;

                    if (nonVideo == true) {
                        cancellaFileFisico = confirm('Eliminare anche il file fisico dal server?');
                    }

                    CallServiceAsync('/Documenti/EliminaDocumento', { IdDocumento: docID, CancellaFileFisico: cancellaFileFisico })
                        .then((risp) => {
                            if (risp.Esito == Costanti.ESITO_OK) {
                                Notify.Message(risp.ResponseText, risp.NotifyColor);

                                var btnSubmit = $('#btnSubmitFormSearchDocumenti');
                                if (btnSubmit && btnSubmit.length > 0) {
                                    btnSubmit.click();
                                }
                            }
                            else {
                                Notify.Message(risp.ResponseText, risp.NotifyColor);
                                Waiter.Hide();
                            }
                        })
                        .catch((ex) => {
                            console.log(ex);
                            Notify.GenericError();
                            Waiter.Hide();
                        })
                }
                else {
                    Waiter.Hide();
                }
            })
            .catch((ex) => {
                console.log(ex);
                Notify.GenericError();
                Waiter.Hide();
            })

    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
    }
}

var lastTabEtichetteLingue = 0;
function UpdateEtichetteLingueJS(formID, tabPanelID) {
    try {

        Waiter.Show();

        var tabPane = $('#' + tabPanelID).dxTabPanel('instance');
        lastTabEtichetteLingue = tabPane.option('selectedIndex');

        var p = {
            ETCO_LING_Lcid: $('#' + formID + ' #ETCO_LING_Lcid').val(),
            ETCO_ETIC_Id: $('#' + formID + ' #ETCO_ETIC_Id').val(),
            ETCO_Id: $('#' + formID + ' #ETCO_Id').val(),
            ETCO_Content: $('#' + formID + ' #ETCO_Content').val()
        };

        CallServiceAsync('/Etichette/UpdateEtichetteLingueJS', p)
            .then((risp) => {
                if (risp && risp == true) {
                    Notify.Message('Etichette aggiornate correttamente', Costanti.NOTIFY_COLOR_SUCCESS);
                    $('#gridContainer').dxDataGrid('instance').getDataSource().reload();

                    setTimeout(() => {
                        $('#' + tabPanelID).dxTabPanel('instance').option('selectedIndex', lastTabEtichetteLingue);
                        lastTabEtichetteLingue = 0;
                        $('#' + formID + ' #ETCO_Content').focus();
                    }, 1000);

                    Waiter.Hide();
                }
            })
            .then((ex) => {
                console.log(ex);
                Waiter.Hide();
            })

    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
    }

    return false;
}

function SelectBoxLingue_OnValueChanged(e) {
    try {

        if (e.value == null) {
            e.component.option('value', 0);
        }

    } catch (ex) {
        console.log(ex);
    }
}

function ddlTipologie_OnValueChanged(e) {
    try {

        if (e.value == null) {
            e.component.option('value', 0);
        }

        var lingueSelectBox = $('#ddlLingue').dxSelectBox('instance');

        if (!lingueSelectBox) return;

        var oldValue = lingueSelectBox.option('value');

        lingueSelectBox.option('value', null);

        if (!(e.value == 2 || e.value == 14 || e.value == 23)) {

            var filtri = [
                ['LITR_Lcid_Origine', '=', 1033],
                'OR',
                ['LITR_Lcid_Origine', '=', 1036],
                'OR',
                ['LITR_Lcid_Origine', '=', 1040],
                'OR',
                ['LITR_Lcid_Origine', '=', 99999]
            ];

            lingueSelectBox.getDataSource().filter(filtri);
        } else {
            lingueSelectBox.getDataSource().filter(null);
        }

        lingueSelectBox.getDataSource().load();

        if (lingueSelectBox.getDataSource().items().filter(x => x.LITR_Lcid_Origine == oldValue).length > 0) {
            lingueSelectBox.option('value', oldValue);
        }

        // il cambio di tipologia cambia le sotto tipologie disponibili: riallinea il campo SKU
        var ddlSotto = $('#ddlSottotipologie');
        if (ddlSotto.length > 0) {
            ToggleRiferimentoSKU(ddlSotto.dxSelectBox('instance').option('value'));
        }

    } catch (ex) {
        console.log(ex);
    }
}


var fatto = false;
function gridContainerX_ContentReady(e) {
    if (fatto == false) {
        DataGridCommonSettings();
        fatto = true;
    }
}

function ClearCacheGlobale() {
    var msg = 'Sei sicuro di voler cancellare la cache GLOBALE del frontend?';
    var url = '/Cache/ClearCacheFrontend';
    CommonCancellaCache(msg, url);
}

function ClearCacheEtichette() {
    var msg = 'Sei sicuro di voler cancellare la cache delle etichette?';
    var url = '/Cache/ClearCacheEtichetteFrontend';
    CommonCancellaCache(msg, url);
}

// Autore: Claude
function ClearCacheBackend() {
    try {
        var msg = 'Sei sicuro di voler cancellare la cache del backend (GimaGestione)?';
        var url = '/Cache/ClearCacheBackend';
        CommonCancellaCache(msg, url);
    } catch (ex) {
        console.error(ex);
    }
}

function CommonCancellaCache(msg, url) {
    DevExpress.ui.dialog.confirm(msg, 'Conferma cancellazione').done(result => {
        if (result) {
            Waiter.Show();
            CallServiceAsync(url, {})
                .then(response => {
                    Waiter.Hide();
                    if (response.Esito == Costanti.ESITO_OK) {
                        Notify.Message(response.ResponseText, Costanti.NOTIFY_COLOR_SUCCESS);
                    } else {
                        Notify.Message(response.ResponseText, Costanti.NOTIFY_COLOR_ERROR);
                    }
                })
                .catch((xhr, status, error) => {
                    Waiter.Hide();
                    Notify.Message('Cache NON cancellata', Costanti.NOTIFY_COLOR_ERROR);
                });
        }
    });
}
function gridTipiDispositivo_RowRemoving(e) {

    e.cancel = true;
    Waiter.Show();

    try {

        CallServiceAsync('/Product/CheckTipoDispositivoUsato', { key: e.key })
            .then(prods => {
                var esito = true;
                if (prods > 0) {
                    esito = confirm('Attenzione: questo tipo di dispositivo è associato a ' + prods + ' prodotti. Eliminandolo verranno rimossi anche questi collegamenti. Continuare?');
                }

                if (esito) {
                    CallServiceAsync('/Product/DeleteTipoDispositivo', { key: e.key })
                        .then(result => {
                            if (result) {
                                Notify.Message("Tipo dispositivo eliminato con successo", Costanti.NOTIFY_COLOR_SUCCESS);
                            }
                            else {
                                Notify.Message("Errore durante l'eliminazione", Costanti.NOTIFY_COLOR_ERROR);
                            }

                            $('#gridTipiDispositivo').dxDataGrid('instance').getDataSource().reload();
                            Waiter.Hide();
                        })
                        .catch(error => {
                            Notify.Message("Errore durante l'eliminazione", Costanti.NOTIFY_COLOR_ERROR);
                            Waiter.Hide();
                        });
                }
                else {
                    Waiter.Hide();
                }
            })
            .catch(error => {
                console.log(error);
                Waiter.Hide();
            })

    } catch (ex) {
        console.log(ex);
        Waiter.Hide();
    }
}

function ConfermaEliminaProdottoFisico(sku) {
    try {
        Waiter.Show();
        CallServiceAsync('/Product/VerificaProdottoEliminabile', { sku: sku })
            .then(result => {
                Waiter.Hide();
                var forza = false;
                var msg = 'Sei sicuro di voler eliminare fisicamente il prodotto ' + sku + ' e tutte le sue relazioni tabellari? L\'operazione non è reversibile.';

                if (result.ordini > 0 || result.carrelli > 0 || result.rma > 0) {
                    forza = true;
                    msg = 'Attenzione: il prodotto ' + sku + ' è presente in ' + result.ordini + ' ordini, ' + result.carrelli +
                        ' carrelli e ' + result.rma + ' RMA. Eliminandolo fisicamente verranno rimosse anche queste relazioni. Continuare?';
                }

                if (confirm(msg)) {
                    $('#fEliminaProd' + sku + ' input[name="forza"]').val(forza);
                    Waiter.Show();
                    $('#fEliminaProd' + sku).submit();
                }
            })
            .catch(error => {
                console.error(error);
                Waiter.Hide();
                Notify.Message('Errore durante la verifica del prodotto', Costanti.NOTIFY_COLOR_ERROR);
            });
    } catch (ex) {
        console.error(ex);
        Waiter.Hide();
    }
}

function SalvaTutteLeLingueTipoDispositivo(tidiId) {
    try {
        Waiter.Show();
        var dati = [];

        var tabPanel = $('#tabpanel-traduzioni').dxTabPanel('instance');

        if (tabPanel != undefined) {
            var index = tabPanel.option('selectedIndex');

            for (var i = 0; i < tabPanel.option('items').length; i++) {
                tabPanel.option('selectedIndex', i);
            }

            tabPanel.option('selectedIndex', index);

            var dati = [];

            $('[id^=formTDCO_]').each((index, item) => {

                dati[index] = {
                    TDCO_Id: $('#' + item.id + ' #TDCO_Id').val(),
                    TDCO_TipoDispositivo: $('#' + item.id + ' #TDCO_TipoDispositivo').val(),
                    TDCO_LING_Lcid: $('#' + item.id + ' #TDCO_LING_Lcid').val(),
                    TDCO_TIDI_Id: tidiId
                };
            });
        }

        if (dati.length > 0) {
            var params = {
                dati
            };
            CallServiceAsync('/Product/UpdateTipoDispositivoContenutiBulk', params)
                .then(result => {
                    if (result.filter(x => x != true).length == result.length) {
                        Notify.Message("Errore durante il salvataggio", Costanti.NOTIFY_COLOR_ERROR);
                    }
                    else if (result.filter(x => x != true).length > 0) {
                        Notify.Message("Non tutti i dati sono stati salvati, controllare", Costanti.NOTIFY_COLOR_WARNING);
                        $('#gridTipiDispositivo').dxDataGrid('instance').getDataSource().reload();
                    }
                    else {
                        Notify.Message("Tipo dispositivo salvato con successo", Costanti.NOTIFY_COLOR_SUCCESS);
                        $('#gridTipiDispositivo').dxDataGrid('instance').getDataSource().reload();
                    }
                    Waiter.Hide();
                })
                .catch(error => {
                    Notify.Message("Errore durante il salvataggio", Costanti.NOTIFY_COLOR_ERROR);
                    Waiter.Hide();
                })
        }
    } catch (ex) {
        console.error(ex);
        Waiter.Hide();
    }
}

// Autore: Claude
function ExportTipiDispositivoExcel() {
    try {
        Waiter.Show();

        CallServiceAsync('/Product/ExportTipiDispositivoExcel')
            .then((response) => {
                if (response.Esito == Costanti.ESITO_KO) {
                    Notify.Message("Errore durante il download del file", Costanti.NOTIFY_COLOR_ERROR);
                }
                else {
                    var blob = new Blob([s2ab(atob(response.File))], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                    });

                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'TipiDispositivo_' + DateTimeNow() + '.xlsx';
                    link.click();
                }
                Waiter.Hide();
            })
            .catch((error) => {
                console.log(error);
                Notify.GenericError();
                Waiter.Hide();
            });

    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

// Autore: Claude
function ExportStockFittizioExcel() {
    try {
        Waiter.Show();

        CallServiceAsync('/Product/ExportStockFittizioExcel')
            .then((response) => {
                if (response.Esito == Costanti.ESITO_KO) {
                    Notify.Message("Errore durante il download del file", Costanti.NOTIFY_COLOR_ERROR);
                }
                else {
                    var blob = new Blob([s2ab(atob(response.File))], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                    });

                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'StockFittizio_' + DateTimeNow() + '.xlsx';
                    link.click();
                }
                Waiter.Hide();
            })
            .catch((error) => {
                console.log(error);
                Notify.GenericError();
                Waiter.Hide();
            });

    } catch (err) {
        console.log(err);
        Waiter.Hide();
    }
}

// Autore: Claude
function onConfirmDeleteConf(e) {
    try {
        var d = $.Deferred();
        CallServiceAsync("/Confezionamento/GetProdottiConfezionamento", { id: e.data.CONF_Id }).then((count) => {
            var msg = "<div class='text-center py-3'>" +
                "<p class='mt-3 mb-0'>Sei sicuro di voler eliminare il confezionamento <b>" + e.data.CONF_Etichetta + "</b>?</p>";
            if (count > 0) {
                var frase = count == 1 ? "c\'è <b>1</b> prodotto che utilizza" : "ci sono <b>" + count + "</b> prodotti che utilizzano";
                msg += "<p class='mt-2'><b>Attenzione:</b> " + frase + " questo confezionamento.<br/>" +
                    "Cliccando <b>\'Elimina\'</b> i prodotti verranno disassociati da questo confezionamento.</p>";
            }
            msg += "</div>";
            DevExpress.ui.dialog.custom({
                title: "Conferma eliminazione",
                messageHtml: msg,
                buttons: [
                    {
                        text: "Annulla",
                        onClick: () => {
                            return false;
                        }
                    },
                    {
                        text: "Elimina",
                        type: "danger",
                        onClick: () => {
                            return true;
                        }
                    }
                ]
            }).show().then((result) => {
                d.resolve(!result);
            });
        });
        e.cancel = d.promise();
    } catch (ex) {
        console.error(ex);
    }
}

function SalvaTutteLeLingueCategorie(cateID) {
    var grid = $('#gridContainer').dxDataGrid('instance');
    try {

        if (confirm('Salvare i dati di tutte le lingue?')) {

            var tabPanel = $('#tabpanel-container').dxTabPanel('instance');

            if (tabPanel != undefined) {
                var index = tabPanel.option('selectedIndex');

                tabPanel.option('selectedIndex', 0);
                tabPanel.option('selectedIndex', 1);
                tabPanel.option('selectedIndex', 2);

                tabPanel.option('selectedIndex', index);

                var dati = [];
                var valid = true;

                $('[id^=fCategorieLingua_]').each((index, item) => {

                    var nome = $('#' + item.id + ' #CACO_Nome').val();

                    if (nome.trim().length == 0) {
                        Notify.Message('Per salvare i dati bisogna compilare tutti i campi Nome', Costanti.NOTIFY_COLOR_ERROR);
                        $('#' + item.id + ' #CACO_Nome').addClass('is-invalid');
                        valid = false;
                    }
                    else {
                        $('#' + item.id + ' #CACO_Nome').removeClass('is-invalid');
                    }
                    dati[index] = {
                        CACO_id: $('#' + item.id + ' #CACO_id').val(),
                        CACO_CATE_Id: $('#' + item.id + ' #CACO_CATE_Id').val(),
                        CACO_LING_Lcid: $('#' + item.id + ' #CACO_LING_Lcid').val(),
                        CACO_Nome: nome
                    };
                });

                console.log(dati);

                if (valid == true) {
                    var params = {
                        dati
                    };
                    Waiter.Show();

                    CallServiceAsync('/Categorie/UpdateCategoriaLingueBulk', params)
                        .then((r) => {

                            if (r.filter((item) => { return item == false }).length == r.length) {
                                Notify.Message('Errore durante il salvataggio', Costanti.NOTIFY_COLOR_ERROR);
                            }
                            else if (r.filter((item) => { return item == false }).length == 0) {
                                Notify.Message('Dati salvati correttamente', Costanti.NOTIFY_COLOR_SUCCESS);
                            }
                            else {
                                Notify.Message('Errore, non tutti i dati sono stati salvati', Costanti.NOTIFY_COLOR_WARNING);
                            }

                            grid.getDataSource().reload();
                            grid.collapseAll(-1);

                            Waiter.Hide();
                        })
                        .catch((ex) => {
                            console.log(ex);
                            grid.getDataSource().reload();
                            Waiter.Hide();
                        });
                }
            }
        }

    } catch (ex) {
        console.log(ex);
        grid.Hide();
    }
}

function CategorieConfirmDelete(e) {
    try {
        console.log(e);
        var d = $.Deferred();
        CallServiceAsync("/Categorie/GetProdottiCategoria", { id: e.key }).then((count) => {
            var msg = "<div class='text-center py-3'>" +
                "<p class='mt-3 mb-0'>Sei sicuro di voler eliminare la categoria <b>" + e.data.CATE_Etichetta + "</b>?</p>";
            if (count > 0) {
                var frase = count == 1 ? "c\'è <b>1</b> prodotto legato" : "ci sono <b>" + count + "</b> prodotti legati";
                msg += "<p class='mt-2'><b>Attenzione:</b> " + frase + " a questa categoria.<br/>" +
                    "Cliccando <b>\'Elimina\'</b> i prodotti verranno disassociati da questa categoria.</p>";
            }
            msg += "</div>";
            DevExpress.ui.dialog.custom({
                title: "Conferma eliminazione",
                messageHtml: msg,
                buttons: [
                    {
                        text: "Annulla",
                        onClick: () => {
                            return false;
                        }
                    },
                    {
                        text: "Elimina",
                        type: "danger",
                        onClick: () => {
                            return true;
                        }
                    }
                ]
            }).show().then((result) => {
                d.resolve(!result);
            });
        });
        e.cancel = d.promise();
    } catch (ex) {
        console.error(ex);
    }
}

/**
 * Autore: Claude
 * Inizializza un editor WYSIWYG TinyMCE (DOM-based) su una textarea, per l'editing di HTML
 * strutturato (div/section/classi/style/id annidati) che il DevExtreme HtmlEditor (Quill)
 * appiattirebbe. TinyMCE lavora direttamente sull'HTML e lo preserva; al submit del form
 * risincronizza automaticamente il contenuto sulla textarea originale (POST invariato).
 * @param {string} selector - selettore CSS della textarea (es. '#ETCO_Content').
 * @param {string|string[]} [contentCss] - URL (o array di URL) di CSS da caricare DENTRO
 *        l'iframe dell'editor, per rendere visibili le classi custom (es. site.css del front).
 *        TinyMCE renderizza il contenuto in un iframe isolato: gli stili della pagina esterna
 *        NON lo raggiungono, solo cio' che si passa qui (o via content_style).
 *        Default: bootstrap locale (card/row/col).
 */
function InitHtmlWysiwyg(selector, contentCss) {
    try {
        if (typeof tinymce === 'undefined') {
            console.error('InitHtmlWysiwyg: libreria TinyMCE non caricata');
            return;
        }

        tinymce.init({
            selector: selector,
            height: 500,
            width: 1000,
            menubar: 'edit insert format table',
            plugins: 'lists link image table code',
            toolbar: 'undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image table | code',
            contextmenu: false,                // click destro = menu nativo del browser, non quello di TinyMCE
            // --- Preserva l'HTML cosi' com'e', senza pulizie/riscritture ---
            valid_elements: '*[*]',            // ammette qualsiasi tag e qualsiasi attributo
            extended_valid_elements: 'section[*],div[*],a[*],span[*]',
            // Consente gli annidamenti non standard del catalogo (es. <div> dentro <a>)
            valid_children: '+body[section|div|style],+a[div|span|section|h5|p|ul|li|img],+div[div|section|a|h5|p|ul|li|img]',
            verify_html: false,
            convert_urls: false,               // NON riscrive gli href relativi (/documenti/...)
            relative_urls: false,
            entity_encoding: 'raw',            // mantiene accenti/apostrofi senza convertirli in entita'
            // CSS caricati nell'iframe: quelli passati dal chiamante, oppure bootstrap locale di default
            content_css: contentCss || '/lib/bootstrap/dist/css/bootstrap.min.css',
            // CSS inline iniettato nell'iframe: da' respiro al contenuto (che altrimenti parte attaccato in alto)
            content_style: 'body { padding-top: 2rem; padding-bottom: 2rem; }'
        });
    } catch (ex) {
        console.error(ex);
    }
}


/**
 * Gestione del proprio account (Views/Account/MioAccount.cshtml e Views/Account/CambiaPassword.cshtml).
 * Le password viaggiano solo verso il server: la validazione lato client serve a evitare andate e ritorni
 * inutili, quella che conta e' quella di GestioneAdminUser.
 * Autore: Claude
 */
var Account = (function () {

    /**
    * Ritorna il token antiforgery reso dalla pagina, da accodare ai POST che modificano l'account.
    * Le action lato server sono marcate [ValidateAntiForgeryToken]: senza questo campo rispondono 400.
    */
    function GetToken() {
        try {
            return $('input[name="__RequestVerificationToken"]').val() || '';
        } catch (ex) {
            console.error(ex);
            return '';
        }
    }

    /**
    * Cambia la password dell'utente corrente.
    * @param {string} urlRedirect - URL su cui portare l'utente in caso di successo; se assente resta sulla pagina
    */
    function SalvaPassword(urlRedirect) {
        try {
            var passwordAttuale = $('#PasswordAttuale').val();
            var passwordNuova = $('#PasswordNuova').val();
            var confermaPassword = $('#ConfermaPassword').val();

            if (!passwordAttuale) { Notify.GenericError('Inserire la password attuale'); return; }
            if (!passwordNuova) { Notify.GenericError('Inserire la nuova password'); return; }
            if (passwordNuova !== confermaPassword) { Notify.GenericError('La nuova password e la conferma non coincidono'); return; }

            Waiter.Show();
            CallServiceAsync('/Account/SalvaPassword', {
                passwordAttuale: passwordAttuale,
                passwordNuova: passwordNuova,
                confermaPassword: confermaPassword,
                __RequestVerificationToken: GetToken()
            })
                .then(function (result) {
                    Waiter.Hide();
                    Notify.Message(result.ResponseText, result.NotifyColor);

                    if (result.Esito === 'ok') {
                        $('#PasswordAttuale').val('');
                        $('#PasswordNuova').val('');
                        $('#ConfermaPassword').val('');

                        if (urlRedirect) {
                            // Il cookie e' stato riemesso senza il claim di password scaduta: da qui in poi
                            // la navigazione non viene piu' dirottata sul cambio password.
                            window.setTimeout(function () { window.location.href = urlRedirect; }, 1500);
                        }
                    }
                })
                .catch(function (err) {
                    Waiter.Hide();
                    console.error(err);
                    Notify.GenericError('Errore durante il cambio password');
                });
        } catch (ex) { console.error(ex); }
    }

    /**
    * Cambia l'email di login dell'utente corrente.
    */
    function SalvaEmail() {
        try {
            var nuovaEmail = ($('#NuovaEmail').val() || '').trim();
            var passwordAttuale = $('#PasswordConfermaEmail').val();

            if (!nuovaEmail) { Notify.GenericError('Inserire la nuova email'); return; }
            if (!passwordAttuale) { Notify.GenericError('Inserire la password attuale per confermare'); return; }

            Waiter.Show();
            CallServiceAsync('/Account/SalvaEmail', {
                nuovaEmail: nuovaEmail,
                passwordAttuale: passwordAttuale,
                __RequestVerificationToken: GetToken()
            })
                .then(function (result) {
                    Waiter.Hide();
                    Notify.Message(result.ResponseText, result.NotifyColor);

                    if (result.Esito === 'ok') {
                        // Ricarica: email e claim sono cambiati, la pagina mostrerebbe ancora i valori vecchi.
                        window.setTimeout(function () { window.location.href = '/Account/MioAccount'; }, 1500);
                    }
                })
                .catch(function (err) {
                    Waiter.Hide();
                    console.error(err);
                    Notify.GenericError('Errore durante il cambio email');
                });
        } catch (ex) { console.error(ex); }
    }

    /**
    * Salva il numero di telefono dell'utente corrente.
    */
    function SalvaTelefono() {
        try {
            var cellulare = ($('#Cellulare').val() || '').trim();

            Waiter.Show();
            CallServiceAsync('/Account/SalvaTelefono', { cellulare: cellulare, __RequestVerificationToken: GetToken() })
                .then(function (result) {
                    Waiter.Hide();
                    Notify.Message(result.ResponseText, result.NotifyColor);
                })
                .catch(function (err) {
                    Waiter.Hide();
                    console.error(err);
                    Notify.GenericError('Errore durante il salvataggio del telefono');
                });
        } catch (ex) { console.error(ex); }
    }

    /**
    * Richiede il link di reset password per l'indirizzo indicato.
    * La risposta e' volutamente identica sia che l'account esista sia che non esista.
    */
    function InviaResetPassword() {
        try {
            var email = ($('#EmailReset').val() || '').trim();

            if (!email) { Notify.GenericError('Inserire l\'indirizzo email'); return; }

            Waiter.Show();
            CallServiceAsync('/Account/InviaResetPassword', {
                email: email,
                __RequestVerificationToken: GetToken()
            })
                .then(function (result) {
                    Waiter.Hide();
                    Notify.Message(result.ResponseText, result.NotifyColor);

                    if (result.Esito === 'ok') {
                        // Il messaggio resta a schermo: il toast sparisce, e qui l'utente deve
                        // andare a controllare la posta.
                        $('#EsitoReset').text(result.ResponseText).show();
                        $('#EmailReset').val('');
                        $('#BtnInviaReset').prop('disabled', true);
                    }
                })
                .catch(function (err) {
                    Waiter.Hide();
                    console.error(err);
                    Notify.GenericError('Errore durante la richiesta di reset');
                });
        } catch (ex) { console.error(ex); }
    }

    /**
    * Applica la nuova password usando il token di reset ricevuto per mail.
    */
    function SalvaResetPassword() {
        try {
            var token = $('#TokenReset').val();
            var passwordNuova = $('#PasswordNuova').val();
            var confermaPassword = $('#ConfermaPassword').val();

            if (!token) { Notify.GenericError('Link di reset non valido'); return; }
            if (!passwordNuova) { Notify.GenericError('Inserire la nuova password'); return; }
            if (passwordNuova !== confermaPassword) { Notify.GenericError('La nuova password e la conferma non coincidono'); return; }

            Waiter.Show();
            CallServiceAsync('/Account/SalvaResetPassword', {
                token: token,
                passwordNuova: passwordNuova,
                confermaPassword: confermaPassword,
                __RequestVerificationToken: GetToken()
            })
                .then(function (result) {
                    Waiter.Hide();
                    Notify.Message(result.ResponseText, result.NotifyColor);

                    if (result.Esito === 'ok') {
                        $('#PasswordNuova').val('');
                        $('#ConfermaPassword').val('');
                        window.setTimeout(function () { window.location.href = '/Account/Login'; }, 2000);
                    }
                })
                .catch(function (err) {
                    Waiter.Hide();
                    console.error(err);
                    Notify.GenericError('Errore durante il reset della password');
                });
        } catch (ex) { console.error(ex); }
    }

    return {
        'SalvaPassword': SalvaPassword,
        'SalvaEmail': SalvaEmail,
        'SalvaTelefono': SalvaTelefono,
        'InviaResetPassword': InviaResetPassword,
        'SalvaResetPassword': SalvaResetPassword
    }

})();


// ============================================================================
// GIMANET - revisione delle candidature alla rete partner. Autore: Claude
// ============================================================================

/**
 * Colora e nomina lo stato della candidatura nella griglia.
 * @param {object} container - cella della griglia
 * @param {object} options - dati della riga
 */
function GimanetCellaStato(container, options) {
    try {
        var stati = {
            0: { nome: 'Bozza', classe: 'bg-light text-dark' },
            10: { nome: 'Inviata', classe: 'bg-primary' },
            20: { nome: 'In revisione', classe: 'bg-info text-dark' },
            30: { nome: 'Integrazioni richieste', classe: 'bg-warning text-dark' },
            40: { nome: 'Approvata', classe: 'bg-success' },
            60: { nome: 'Rifiutata', classe: 'bg-danger' },
            80: { nome: 'Revocata', classe: 'bg-secondary' }
        };

        var stato = stati[options.data.Stato] || { nome: '-', classe: 'bg-light text-dark' };

        $('<span>').addClass('badge ' + stato.classe).text(stato.nome).appendTo(container);
    } catch (ex) { console.error(ex); }
}

/**
 * Mostra il codice cliente ACG segnalando se e' stato riscontrato in anagrafica.
 * @param {object} container - cella della griglia
 * @param {object} options - dati della riga
 */
function GimanetCellaCodiceCliente(container, options) {
    try {
        if (!options.data.CodCliACG) {
            $('<span>').addClass('text-muted').text('nuovo contatto').appendTo(container);
            return;
        }

        $('<span>').text(options.data.CodCliACG).appendTo(container);

        if (!options.data.AcgVerificato) {
            $('<span>').addClass('badge bg-warning text-dark ms-1').attr('title', 'non riscontrato in ACG').text('?').appendTo(container);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Evidenzia i giorni di attesa delle candidature non ancora revisionate.
 * @param {object} container - cella della griglia
 * @param {object} options - dati della riga
 */
function GimanetCellaAttesa(container, options) {
    try {
        var giorni = options.data.GiorniAttesa;

        if (!giorni || options.data.DataRevisione) {
            return;
        }

        var classe = giorni >= 2 ? 'bg-danger' : (giorni >= 1 ? 'bg-warning text-dark' : 'bg-light text-dark');

        $('<span>').addClass('badge ' + classe).text(giorni + (giorni === 1 ? ' giorno' : ' giorni')).appendTo(container);
    } catch (ex) { console.error(ex); }
}

/**
 * Mostra lo stato di pubblicazione nell'elenco dealer.
 * @param {object} container - cella della griglia
 * @param {object} options - dati della riga
 */
function GimanetCellaPubblicato(container, options) {
    try {
        if (options.data.Pubblicato) {
            $('<span>').addClass('badge bg-success').text('pubblicato').appendTo(container);
        }
        else if (options.data.Stato === 40 && options.data.AutorizzazioneWeb) {
            $('<span>').addClass('badge bg-warning text-dark').text('da pubblicare').appendTo(container);
        }
        else {
            $('<span>').addClass('text-muted').text('-').appendTo(container);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Pulsante di apertura della scheda di revisione.
 * @param {object} container - cella della griglia
 * @param {object} options - dati della riga
 */
function GimanetCellaAzioni(container, options) {
    try {
        $('<a>')
            .addClass('btn btn-sm btn-outline-primary')
            .attr('href', '/Gimanet/DettaglioCandidatura/' + options.data.GNPA_Id)
            .text('Apri')
            .appendTo(container);
    } catch (ex) { console.error(ex); }
}

/**
 * Apre la scheda di revisione al doppio clic sulla riga.
 * @param {object} e - evento della griglia
 */
function GimanetApriDettaglio(e) {
    try {
        if (e && e.data && e.data.GNPA_Id) {
            window.location.href = '/Gimanet/DettaglioCandidatura/' + e.data.GNPA_Id;
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Inizializza l'editor HTML del profilo aziendale nella scheda di revisione.
 * @param {string} html - profilo attuale
 */
function GimanetInizializzaEditorProfilo(html) {
    try {
        $('#gnEditorProfilo').dxHtmlEditor({
            value: html || '',
            height: 220,
            valueType: 'html',
            toolbar: {
                items: ['bold', 'italic', 'underline', 'separator', 'orderedList', 'bulletList', 'separator', 'link', 'separator', 'undo', 'redo']
            }
        });
    } catch (ex) { console.error(ex); }
}

/**
 * Esegue un'azione di revisione sulla candidatura e ricarica la scheda.
 * @param {string} url - url dell'azione
 * @param {object} parametri - parametri da inviare
 * @param {string} testoAttesa - messaggio del pannello di attesa
 */
function GimanetEseguiAzione(url, parametri, testoAttesa) {
    try {
        Waiter.Show(testoAttesa);

        CallServiceAsync(url, parametri)
            .then(function (r) {
                Waiter.Hide();

                if (r && r.Esito === Costanti.ESITO_OK) {
                    Notify.Message(r.ResponseText, Costanti.NOTIFY_COLOR_SUCCESS);
                    window.setTimeout(function () { window.location.reload(); }, 1200);
                }
                else {
                    Notify.GenericError(r ? r.ResponseText : null);
                }
            })
            .catch(function (err) {
                Waiter.Hide();
                console.error(err);
                Notify.GenericError("Errore durante l'operazione");
            });
    } catch (ex) { console.error(ex); }
}

/**
 * Prende in carico la candidatura.
 * @param {number} id - id della candidatura
 */
function GimanetPrendiInCarico(id) {
    try {
        GimanetEseguiAzione('/Gimanet/PrendiInCarico', { id: id }, 'Presa in carico...');
    } catch (ex) { console.error(ex); }
}

/**
 * Approva la candidatura.
 * @param {number} id - id della candidatura
 */
function GimanetApprova(id) {
    try {
        if (!confirm('Approvare la candidatura? Al candidato viene inviata la mail di accettazione.')) {
            return;
        }

        GimanetEseguiAzione('/Gimanet/Approva', { id: id, note: $('#gnNote').val() }, 'Approvazione in corso...');
    } catch (ex) { console.error(ex); }
}

/**
 * Rifiuta la candidatura: la motivazione e' obbligatoria perche' finisce nella mail al candidato.
 * @param {number} id - id della candidatura
 */
function GimanetRifiuta(id) {
    try {
        var motivo = $('#gnMotivo').val();

        if (!motivo || motivo.trim().length === 0) {
            Notify.GenericError('Indicare la motivazione da comunicare al candidato');
            return;
        }

        if (!confirm('Rifiutare la candidatura? Al candidato viene inviata la mail con la motivazione.')) {
            return;
        }

        GimanetEseguiAzione('/Gimanet/Rifiuta', { id: id, motivo: motivo, note: $('#gnNote').val() }, 'Registrazione del rifiuto...');
    } catch (ex) { console.error(ex); }
}

/**
 * Rimanda la candidatura al candidato chiedendo integrazioni.
 * @param {number} id - id della candidatura
 */
function GimanetChiediIntegrazioni(id) {
    try {
        var motivo = $('#gnMotivo').val();

        if (!motivo || motivo.trim().length === 0) {
            Notify.GenericError('Indicare cosa manca: il testo viene inviato al candidato');
            return;
        }

        GimanetEseguiAzione('/Gimanet/ChiediIntegrazioni', { id: id, motivo: motivo, note: $('#gnNote').val() }, 'Invio della richiesta...');
    } catch (ex) { console.error(ex); }
}

/**
 * Revoca l'adesione di un partner.
 * @param {number} id - id della candidatura
 */
function GimanetRevoca(id) {
    try {
        if (!confirm("Revocare l'adesione? Il partner esce anche dall'elenco pubblico.")) {
            return;
        }

        GimanetEseguiAzione('/Gimanet/Revoca', { id: id, note: $('#gnNote').val() }, 'Revoca in corso...');
    } catch (ex) { console.error(ex); }
}

/**
 * Pubblica il partner nell'elenco dealer.
 * @param {number} id - id della candidatura
 */
function GimanetPubblica(id) {
    try {
        GimanetEseguiAzione('/Gimanet/Pubblica', { id: id }, 'Pubblicazione in corso...');
    } catch (ex) { console.error(ex); }
}

/**
 * Sospende il partner dall'elenco dealer senza togliergli l'approvazione.
 * @param {number} id - id della candidatura
 */
function GimanetSospendi(id) {
    try {
        if (!confirm("Sospendere il partner dall'elenco pubblico? L'approvazione resta valida.")) {
            return;
        }

        GimanetEseguiAzione('/Gimanet/Sospendi', { id: id, note: $('#gnNote').val() }, 'Sospensione in corso...');
    } catch (ex) { console.error(ex); }
}

/**
 * Salva le note interne senza cambiare stato.
 * @param {number} id - id della candidatura
 */
function GimanetSalvaNote(id) {
    try {
        Waiter.Show('Salvataggio note...');

        CallServiceAsync('/Gimanet/SalvaNote', { id: id, note: $('#gnNote').val() })
            .then(function (r) {
                Waiter.Hide();

                if (r && r.Esito === Costanti.ESITO_OK) {
                    Notify.Message(r.ResponseText, Costanti.NOTIFY_COLOR_SUCCESS);
                }
                else {
                    Notify.GenericError(r ? r.ResponseText : null);
                }
            })
            .catch(function (err) {
                Waiter.Hide();
                console.error(err);
                Notify.GenericError('Errore durante il salvataggio delle note');
            });
    } catch (ex) { console.error(ex); }
}

/**
 * Associa il codice cliente ACG alla candidatura, verificandolo in anagrafica.
 * @param {number} id - id della candidatura
 */
function GimanetAssociaCodice(id) {
    try {
        var codice = $('#gnCodiceAcg').val();

        if (!codice || codice.trim().length === 0) {
            Notify.GenericError('Indicare il codice cliente');
            return;
        }

        GimanetEseguiAzione('/Gimanet/AssociaCodiceCliente', { id: id, codice: codice }, 'Verifica del codice cliente...');
    } catch (ex) { console.error(ex); }
}

/**
 * Salva il profilo aziendale modificato dal backoffice.
 * @param {number} id - id della candidatura
 */
function GimanetSalvaProfilo(id) {
    try {
        var editor = $('#gnEditorProfilo').dxHtmlEditor('instance');
        var html = editor ? editor.option('value') : '';

        Waiter.Show('Salvataggio profilo...');

        CallServiceAsync('/Gimanet/SalvaProfilo', { id: id, html: html })
            .then(function (r) {
                Waiter.Hide();

                if (r && r.Esito === Costanti.ESITO_OK) {
                    Notify.Message(r.ResponseText, Costanti.NOTIFY_COLOR_SUCCESS);
                }
                else {
                    Notify.GenericError(r ? r.ResponseText : null);
                }
            })
            .catch(function (err) {
                Waiter.Hide();
                console.error(err);
                Notify.GenericError('Errore durante il salvataggio del profilo');
            });
    } catch (ex) { console.error(ex); }
}

/**
 * Allinea il filtro del campo file ai formati ammessi per il tipo di allegato scelto.
 * Autore: Claude
 */
function GimanetTipoAllegatoCambiato() {
    try {
        var accept = $('#gnTipoAllegato option:selected').data('accept') || '';

        $('#gnFileAllegato').attr('accept', accept).val('');
    } catch (ex) { console.error(ex); }
}

/**
 * Carica dal backoffice un allegato della candidatura (logo, foto sede, altro).
 * Autore: Claude
 * @param {number} id - id della candidatura
 */
function GimanetCaricaAllegato(id) {
    try {
        var file = $('#gnFileAllegato')[0].files[0];

        if (!file) {
            Notify.GenericError('Selezionare un file');
            return;
        }

        var formData = new FormData();
        formData.append('id', id);
        formData.append('tipo', $('#gnTipoAllegato').val());
        formData.append('file', file);

        Waiter.Show('Caricamento file...');

        CallServiceFormDataAsync('/Gimanet/CaricaAllegato', formData)
            .then(function (r) {
                Waiter.Hide();

                if (r && r.Esito === Costanti.ESITO_OK) {
                    Notify.Message(r.ResponseText, Costanti.NOTIFY_COLOR_SUCCESS);
                    window.setTimeout(function () { window.location.reload(); }, 1200);
                }
                else {
                    Notify.GenericError(r ? r.ResponseText : null);
                }
            })
            .catch(function (err) {
                Waiter.Hide();
                console.error(err);
                Notify.GenericError('Errore durante il caricamento del file');
            });
    } catch (ex) { console.error(ex); }
}

/**
 * Elimina un allegato della candidatura.
 * Autore: Claude
 * @param {number} id - id dell'allegato
 */
function GimanetEliminaAllegato(id) {
    try {
        if (!confirm("Eliminare l'allegato? Il file viene cancellato definitivamente.")) {
            return;
        }

        GimanetEseguiAzione('/Gimanet/EliminaAllegato', { id: id }, 'Eliminazione allegato...');
    } catch (ex) { console.error(ex); }
}

// ============================================================
// RMA - Nuovo RMA da gestionale (allineato a GimaFront Reserved/RmaRivenditore)
// Autore: Claude
// ============================================================

var NuovoRma = {
    prodottoIndex: 0,
    CAUSALE_ERRATO_ORDINE: '3',
    CAUSALE_CON_SOTTOCAUSALE: '5'
};

/**
 * Inizializza la maschera di nuovo RMA: stato di blocco del form, griglie bolle e bottoni prodotto.
 * Autore: Claude
 * @param {number} numeroProdotti - numero di blocchi prodotto gia' renderizzati dal server
 */
function NuovoRmaInit(numeroProdotti) {
    try {
        NuovoRma.prodottoIndex = numeroProdotti;

        var causale = $('#causale').val();
        $('#subcau').toggle(causale == NuovoRma.CAUSALE_CON_SOTTOCAUSALE);

        if (causale && causale !== '0') {
            NuovoRmaAttivaForm();
        }
        else {
            NuovoRmaBloccaForm();
        }

        $('.prodotto-block').each(function () {
            NuovoRmaInizializzaBollaGrid($(this).data('prodotto-index'));
        });

        NuovoRmaAggiornaBottoniRimozione();
        NuovoRmaAggiornaVisibilitaProdottoMultiplo();
    } catch (ex) { console.error(ex); }
}

/**
 * Selezione della causale: mostra la sottocausale e sblocca il resto del form.
 * Autore: Claude
 */
function NuovoRmaSelezionaCausale(e) {
    try {
        $('#causale').val(e.value);

        if (e.value == NuovoRma.CAUSALE_CON_SOTTOCAUSALE) {
            $('#subcau').show('slow');
        }
        else {
            $('#subcau').hide();
        }

        if (e.value) {
            NuovoRmaAttivaForm();
        }
        else {
            NuovoRmaBloccaForm();
        }

        NuovoRmaAggiornaBottoniRimozione();
        NuovoRmaAggiornaVisibilitaProdottoMultiplo();
    } catch (ex) { console.error(ex); }
}

/**
 * Selezione della sottocausale.
 * Autore: Claude
 */
function NuovoRmaSelezionaSottoCausale(e) {
    try {
        $('#causale2').val(e.value);
    } catch (ex) { console.error(ex); }
}

/**
 * Il RMA multi prodotto e' ammesso solo per la causale "errato ordine".
 * Autore: Claude
 */
function NuovoRmaAggiornaVisibilitaProdottoMultiplo() {
    try {
        var mostra = $('#causale').val() == NuovoRma.CAUSALE_ERRATO_ORDINE;
        $('#btnAggiungiProdotto').toggle(mostra);
        $('.rimuovi-prodotto-btn').toggle(mostra);
    } catch (ex) { console.error(ex); }
}

/**
 * Blocca le sezioni del form che dipendono dalla causale.
 * Autore: Claude
 */
function NuovoRmaBloccaForm() {
    try {
        var $sezioni = $('.restoform-section');
        $sezioni.addClass('rma-locked');
        $sezioni.find(':input').prop('disabled', true);
        NuovoRmaImpostaDisabledWidget('DataAcquisto', 'dxDateBox', true);
        NuovoRmaImpostaDisabledWidget('Allegati', 'dxFileUploader', true);
    } catch (ex) { console.error(ex); }
}

/**
 * Sblocca le sezioni del form che dipendono dalla causale.
 * Autore: Claude
 */
function NuovoRmaAttivaForm() {
    try {
        var $sezioni = $('.restoform-section');
        $sezioni.removeClass('rma-locked');
        $sezioni.find(':input').prop('disabled', false);
        NuovoRmaImpostaDisabledWidget('DataAcquisto', 'dxDateBox', false);
        NuovoRmaImpostaDisabledWidget('Allegati', 'dxFileUploader', false);
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaImpostaDisabledWidget(id, widget, disabled) {
    try {
        var instance = NuovoRmaGetDxInstance(id, widget);
        if (instance) {
            instance.option('disabled', disabled);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaGetDxInstance(id, widget) {
    try {
        var $el = $('#' + id);
        return $el.length ? ($el.data(widget) || null) : null;
    } catch (ex) {
        console.error(ex);
        return null;
    }
}

/**
 * Inizializza la griglia delle bolle ACG di un blocco prodotto.
 * Autore: Claude
 */
function NuovoRmaInizializzaBollaGrid(idx) {
    try {
        $('#bollegrid__blk' + idx).dxDataGrid({
            showBorders: true,
            rowAlternationEnabled: true,
            hoverStateEnabled: true,
            columnAutoWidth: true,
            onSelectionChanged: function (e) { NuovoRmaSelezionaBolla(e, idx); },
            selection: { mode: 'multiple', showCheckBoxesMode: 'always' },
            columns: [
                { caption: 'DDT', dataField: 'NrBolla', width: 100 },
                { caption: 'Data DDT', dataField: 'DataBolla', dataType: 'date', format: 'dd/MM/yyyy', width: 120 },
                { caption: 'Articolo', dataField: 'Articolo' },
                { caption: 'Lotto', dataField: 'Lotto', width: 120 },
                { caption: 'Numero di serie', dataField: 'Seriale', width: 150 }
            ],
            dataSource: []
        });
    } catch (ex) { console.error(ex); }
}

/**
 * Aggiunge un blocco prodotto clonando il template renderizzato dal server.
 * Autore: Claude
 */
function NuovoRmaAggiungiProdotto() {
    try {
        var idx = NuovoRma.prodottoIndex++;
        var html = $('#tplProdottoRma').html().replace(/__idx__/g, idx);
        var $div = $(html);
        $('#prodotti-container').append($div);
        NuovoRmaInizializzaBollaGrid(idx);
        NuovoRmaRiparsaValidazione();

        NuovoRmaAggiornaBottoniRimozione();
        NuovoRmaAggiornaVisibilitaProdottoMultiplo();
        $('#prodotti-errore').hide();
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaRimuoviProdotto(btn) {
    try {
        $(btn).closest('.prodotto-block').remove();
        NuovoRmaAggiornaBottoniRimozione();
        NuovoRmaRiparsaValidazione();
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaAggiornaBottoniRimozione() {
    try {
        var $blocchi = $('.prodotto-block');
        $blocchi.find('.rimuovi-prodotto-btn').prop('disabled', $blocchi.length <= 1);
    } catch (ex) { console.error(ex); }
}

/**
 * Ricostruisce la validazione unobtrusive dopo aver aggiunto/rimosso campi dinamici.
 * Autore: Claude
 */
function NuovoRmaRiparsaValidazione() {
    try {
        var $form = $('#formNuovoRma');
        if ($form.length && $.validator && $.validator.unobtrusive) {
            $form.removeData('validator').removeData('unobtrusiveValidation');
            $.validator.unobtrusive.parse($form);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Cambio SKU in un blocco prodotto: recupera il nome prodotto e carica le bolle ACG.
 * Autore: Claude
 */
function NuovoRmaRecuperaProdotto(input) {
    try {
        var $blocco = $(input).closest('.prodotto-block');
        var v = input.value;

        if (!v || v.length === 0) {
            $blocco.find('.prodotto-nomeprodotto').val('');
            NuovoRmaCaricaBolle($blocco, v);
            return;
        }

        Waiter.Show();

        CallServiceAsync('/Rma/RecuperoProdotto', { sku: v })
            .then(function (r) {
                if (r != null && r !== 'null' && r.length > 0) {
                    $blocco.find('.prodotto-nomeprodotto').val(r);
                }
                else {
                    $blocco.find('.prodotto-nomeprodotto').val('');
                    Notify.Message('Prodotto non trovato per lo SKU indicato.', Costanti.NOTIFY_COLOR_WARNING);
                }
                Waiter.Hide();
            })
            .catch(function (error) {
                console.error(error);
                Waiter.Hide();
            });

        NuovoRmaCaricaBolle($blocco, v);
    } catch (ex) {
        console.error(ex);
        Waiter.Hide();
    }
}

/**
 * Carica le bolle ACG per codice cliente/sku nel blocco prodotto indicato.
 * Autore: Claude
 */
function NuovoRmaCaricaBolle($blocco, sku) {
    try {
        var idx = $blocco.data('prodotto-index');
        var codiceAcg = $('#CodiceAcg').val();
        var grid = NuovoRmaGetDxInstance('bollegrid__blk' + idx, 'dxDataGrid');

        if (grid) {
            grid.option('dataSource', []);
        }
        $blocco.find("[id^='bollegridcontainer__blk']").hide();
        $blocco.find("[id^='bolleloading__blk']").hide();

        if (!grid || !codiceAcg || !sku) {
            NuovoRmaRipristinaCampiBolla($blocco);
            return Promise.resolve();
        }

        // Blocca e svuota i campi finche' non si conosce l'esito della ricerca delle bolle
        NuovoRmaBloccaCampiBolla($blocco);
        $blocco.find("[id^='bolleloading__blk']").show();

        return CallServiceAsync('/Rma/ElencoBolleSito', { codiceAcg: codiceAcg, sku: sku })
            .then(function (r) {
                if (Array.isArray(r) && r.length > 0) {
                    $blocco.find("[id^='bollegridcontainer__blk']").show();
                    grid.option('dataSource', r);
                    grid.repaint();
                }
                else {
                    NuovoRmaRipristinaCampiBolla($blocco);
                }
            })
            .catch(function (error) {
                console.error(error);
                NuovoRmaRipristinaCampiBolla($blocco);
            })
            .finally(function () {
                $blocco.find("[id^='bolleloading__blk']").hide();
            });
    } catch (ex) {
        console.error(ex);
        return Promise.resolve();
    }
}

/**
 * Selezione di una bolla: compila lotto, seriale, DDT e data di acquisto (selezione singola).
 * Autore: Claude
 */
function NuovoRmaSelezionaBolla(e, idx) {
    try {
        if (e.currentSelectedRowKeys && e.currentSelectedRowKeys.length > 0 && e.selectedRowKeys.length > 1) {
            e.component.option('selectedRowKeys', [e.currentSelectedRowKeys[0]]);
            return;
        }

        var $blocco = $(".prodotto-block[data-prodotto-index='" + idx + "']");
        var d = e.selectedRowsData && e.selectedRowsData.length > 0 ? e.selectedRowsData[0] : null;

        if (!d) {
            NuovoRmaRipristinaCampiBolla($blocco);
            return;
        }

        NuovoRmaImpostaCampoDaBolla($blocco.find('.prodotto-lotto'), d.Lotto);
        NuovoRmaImpostaCampoDaBolla($blocco.find('.prodotto-numeroserie'), d.Seriale);
        NuovoRmaImpostaCampoDaBolla($('#DDTAcquisto'), d.NrBolla);

        var dxDataAcquisto = NuovoRmaGetDxInstance('DataAcquisto', 'dxDateBox');
        if (dxDataAcquisto) {
            dxDataAcquisto.option('value', d.DataBolla ? new Date(d.DataBolla) : null);
            dxDataAcquisto.option('readOnly', true);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaImpostaCampoDaBolla($el, valore) {
    try {
        $el.val(valore).prop('readOnly', true).css('background', '#e9ecef');
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaBloccaCampiBolla($blocco) {
    try {
        $blocco.find('.prodotto-lotto, .prodotto-numeroserie').val('').prop('readOnly', true).css('background', '#e9ecef');

        var dxDataAcquisto = NuovoRmaGetDxInstance('DataAcquisto', 'dxDateBox');
        if (dxDataAcquisto) {
            dxDataAcquisto.option('value', null);
            dxDataAcquisto.option('readOnly', true);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Autore: Claude
 */
function NuovoRmaRipristinaCampiBolla($blocco) {
    try {
        $blocco.find('.prodotto-lotto, .prodotto-numeroserie').prop('readOnly', false).css('background', '');
        $('#DDTAcquisto').prop('readOnly', false).css('background', '');

        var dxDataAcquisto = NuovoRmaGetDxInstance('DataAcquisto', 'dxDateBox');
        if (dxDataAcquisto) {
            dxDataAcquisto.option('readOnly', false);
        }
    } catch (ex) { console.error(ex); }
}

/**
 * Cambio codice cliente: recupera l'anagrafica ACG e ricarica le bolle dei prodotti gia' inseriti.
 * Autore: Claude
 */
function NuovoRmaRecuperaAnagrafica(v) {
    try {
        var ricaricaBolle = function () {
            $('.prodotto-block').each(function () {
                var $blocco = $(this);
                NuovoRmaCaricaBolle($blocco, $blocco.find('.prodotto-sku').val());
            });
        };

        if (!v || v.length === 0) {
            $('#NomeUtente').val('');
            $('#Email').val('');
            ricaricaBolle();
            return;
        }

        Waiter.Show();

        CallServiceAsync('/Rma/GetAnagraficaDaCodiceACG', { codiceAcg: v })
            .then(function (risp) {
                if (risp != null && risp.Esito === Costanti.ESITO_OK && risp.Data != null) {
                    $('#NomeUtente').val((risp.Data.RagioneSociale || '').trim());
                    if (!$('#Email').val()) {
                        $('#Email').val((risp.Data.Email || '').trim());
                    }
                }
                else {
                    $('#NomeUtente').val('');
                    Notify.Message((risp && risp.ResponseText) || 'Codice cliente non trovato', Costanti.NOTIFY_COLOR_WARNING);
                }
                Waiter.Hide();
                ricaricaBolle();
            })
            .catch(function (error) {
                console.error(error);
                Waiter.Hide();
            });
    } catch (ex) {
        console.error(ex);
        Waiter.Hide();
    }
}

/**
 * Submit del nuovo RMA: valida il form, verifica la presenza di almeno un prodotto e rinumera
 * gli indici Prodotti[i] in modo contiguo (il model binder si ferma al primo indice mancante).
 * Autore: Claude
 */
function NuovoRmaInvia() {
    try {
        var $form = $('#formNuovoRma');
        if ($form.length && typeof $form.valid === 'function' && !$form.valid()) {
            return false;
        }

        var $blocchi = $('.prodotto-block');
        if ($blocchi.length === 0) {
            $('#prodotti-errore').show();
            $('html, body').animate({ scrollTop: $('#prodotti-errore').offset().top - 100 }, 300);
            return false;
        }
        $('#prodotti-errore').hide();

        $blocchi.each(function (i) {
            $(this).find('[name^="Prodotti["]').each(function () {
                this.name = this.name.replace(/^Prodotti\[\d+\]/, 'Prodotti[' + i + ']');
            });
        });

        Waiter.Show();
        return true;
    } catch (ex) {
        console.error(ex);
        return false;
    }
}
